import dayjs from "dayjs";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import PolicyDialog from "../../components/contractor/dialog/policy.vue";
import ConfirmDialog from "../../layouts/confirmDialog/confirmDialog.vue";
import { ContractorTypes } from "../../models/emums/contractorTypes";
import { Roles } from "../../models/emums/roles";
import ListItemNumberModel from "../../models/listItemNumberModel";
import ListItemStringModel from "../../models/listItemStringModel";
import LocalStorageApplicationStateDataModel from "../../models/localStorageApplicationStateDataModel";
import ContractorAssetsRestModel from "../../models/rest/contractor/contractorAssetsRestModel";
import ContractorDetailsForSupervisorRestModel from "../../models/rest/contractor/contractorDetailsForSupervisorRestModel";
import ContractorPolisyRestModel from "../../models/rest/contractor/contractorPolicyRestModel";
import ContractorRestModel from "../../models/rest/contractor/contractorRestModel";
import ContractorSearchItemModel from "../../models/rest/contractor/contractorSearchItemModel";
import CourierNetFreightRestModel from "../../models/rest/freight-exchange/courier-net/courierNetFreightRestModel";
import CourierNetPackageRestModel from "../../models/rest/freight-exchange/courier-net/courierNetPackageRestModel";
import TransEuFreightRestModel from "../../models/rest/freight-exchange/transeu/transEuFreightRestModel";
import MailingContractorCarrierEmailDataModel from "../../models/rest/mailing/mailingContractorCarrierEmailDataModel";
import MailingContractorCarrierEmailPlaceDataModel from "../../models/rest/mailing/mailingContractorCarrierEmailPlaceDataModel";
import BranchRestModel from "../../models/rest/register/branchRestModel";
import CountryRestModel from "../../models/rest/register/countryRestModel";
import CurrencyRestModel from "../../models/rest/register/currencyRestModel";
import DepartmentItemRestModel from "../../models/rest/register/departmentItemRestModel";
import SupervisorEncoryProjectFreightCalculationRestModel from "../../models/rest/supervisor-encory/supervisorEncoryProjectFreightCalculationRestModel";
import SupervisorPlaceEncoryAggregatedByUnRestModel from "../../models/rest/supervisor-encory/supervisorPlaceEncoryAggregatedByUnRestModel";
import SupervisorPlaceEncoryHandlingUnitPartRestModel from "../../models/rest/supervisor-encory/supervisorPlaceEncoryHandlingUnitPartRestModel";
import SupervisorPlaceEncoryHandlingUnitRestModel from "../../models/rest/supervisor-encory/supervisorPlaceEncoryHandlingUnitRestModel";
import SupervisorAttachmentRestModel from "../../models/rest/supervisor/supervisorAttachmentRestModel";
import SupervisorCheckpointRestModel from "../../models/rest/supervisor/supervisorCheckpointRestModel";
import SupervisorMementoItemRestModel from "../../models/rest/supervisor/supervisorMementoItemRestModel";
import SupervisorPlaceAttachmentRestModel from "../../models/rest/supervisor/supervisorPlaceAttachmentRestModel";
import SupervisorPlaceRestModel from "../../models/rest/supervisor/supervisorPlaceRestModel";
import SupervisorPlaceSpecificGoodRestModel, { SupervisorPlaceSpecificGoodItemRestModel, SupervisorPlaceSpecificGoodPackingGroupRestModel, SupervisorPlaceSpecificGoodUnNumberRestModel } from "../../models/rest/supervisor/supervisorPlaceSpecificGoodRestModel";
import SupervisorProcedureRestModel from "../../models/rest/supervisor/supervisorProcedureRestModel";
import SupervisorProjectFreightCalculationRestModel from "../../models/rest/supervisor/supervisorProjectFreightCalculationRestModel";
import SupervisorRestModel from "../../models/rest/supervisor/supervisorRestModel";
import Tiptap from '../custom/tiptap.vue';
import FreightDialog from "../freight-exchange/freight-dialog.vue";
import MailingContractorCarrierDialog from "../mailing/mailing-contractor-carrier-dialog.vue";
import CustomDialog from "../custom/custom-dialog.vue";
import AttachmentDialog from "./dialog/attachment-dialog.vue";
import ContractorContactPersonDialog from "./dialog/contractor-contact-person-dialog.vue";
import ContractorDialog from "./dialog/contractor-dialog.vue";
import EncoryIntegrationDialog from "./dialog/encory-integration-dialog.vue";
import IntegrationDialog from "./dialog/integration-dialog.vue";
import LocationDialog from "./dialog/location-dialog.vue";
import PlaceAttachmentDialog from "./dialog/place-attachment-dialog.vue";
import ProcedureDialog from "./dialog/procedure-dialog.vue";
import SaveSupervisorDialog from "./dialog/save-supervisor-dialog.vue";
import SendingEmailDialog from "./dialog/sending-email-dialog.vue";
import SendingSmsDialog from "./dialog/sending-sms-dialog.vue";
import SpecificGoodItemDialog from "./dialog/specific-good-item-dialog.vue";
import TransportDocumentDgnDialog from "./dialog/transport-document-dgn-dialog.vue";
import TransportDocumentAdrDialog from "./dialog/transport-document-adr-dialog.vue";
import NcEditDialog from "./dialog/nc-edit-dialog.vue";

export interface contractorCarrierPolicyIsActiveResultInterface {
    policyIsActive: boolean;
    checkedPolicyType?: string;
}

@Component({
    components: {
        "attachment-dialog": AttachmentDialog,
        "confirm-dialog": ConfirmDialog,
        "contractor-dialog": ContractorDialog,
        "contractor-contact-person-dialog": ContractorContactPersonDialog,
        "freight-dialog": FreightDialog,
        "integration-dialog": IntegrationDialog,
        "encory-integration-dialog": EncoryIntegrationDialog,
        "location-dialog": LocationDialog,
        "mailing-contractor-carrier-dialog": MailingContractorCarrierDialog,
        "sending-email-dialog": SendingEmailDialog,
        "sending-sms-dialog": SendingSmsDialog,
        "save-supervisor-dialog": SaveSupervisorDialog,
        "place-attachment-dialog": PlaceAttachmentDialog,
        "policy-dialog": PolicyDialog,
        "procedure-dialog": ProcedureDialog,
        "specific-good-item-dialog": SpecificGoodItemDialog,
        "transport-document-dgn-dialog": TransportDocumentDgnDialog,
        "transport-document-adr-dialog": TransportDocumentAdrDialog,
        "nc-edit-dialog": NcEditDialog,
        "custom-dialog": CustomDialog,
        Tiptap,
    }
})

export default class Supervisor extends Vue {
    isEdited = false;
    isFullDuplicating = false;
    currentSupervisorPlaces: SupervisorPlaceRestModel[] = [];
    currentSupervisorCheckpoints: SupervisorCheckpointRestModel[] = [];
    planningDateLabel = this.$t("supervisor.planning");
    planningDateToLabel = this.$t("supervisor.planningTo");
    doneDateLabel = this.$t("supervisor.done");
    kpiReceiptDate = this.$t("supervisor.kpiReceiptDate");
    doneDateConfirmationDialogTitle = this.$t("supervisor.doneDateConfirmationDialogTitle");
    doneDateConfirmationDialogMessage = this.$t("supervisor.doneDateConfirmationDialogMessage");
    contractorSenderSearch = "";
    contractorCarrierSearch = "";
    contractorPayerSearch = "";
    integrationEnabled = false;
    encoryIntegrationEnabled = false;
    kpiEnabled = false;
    showErrorDialog = false;
    timeout: number | undefined;
    canChangeRouteToSupervisorList: boolean = true;
    contractorCarrierPolicyIsActiveResult: contractorCarrierPolicyIsActiveResultInterface = { policyIsActive: true };
    defaultLocationId = (this.supervisor.locationId != undefined && this.supervisor.locationId != 0) ? this.supervisor.locationId : this.currentUserDefaultDepartmentId;
    copyOfDefaultLocationId = this.defaultLocationId;
    previousBranchId: number | undefined = undefined;
    lastSupervisorMementoPoint: number = 0;
    supervisorMementoSelectedPoint: number = 0;
    placesError = null as string | null;
    supervisorIsEditedByAnotherUser = false;
    updateSupervisorLockedForEditingUntilValueIntervalId: any;
    supervisorKilometersHints = "";
    needRecalculatingFreight = false;
    transporeonSupervisorId: number | null = null;
    supervisorPlaceSpecificGoodItemSearch = "";
    supervisorPlaceSpecificGoodItemsFromPlaces = [] as SupervisorPlaceSpecificGoodItemRestModel[];
    searchTimeout = null as any;
    saleValueChanged = false;
    supervisorInitialized = false;
    initialSaleValue: number | null = null;
    showMoveToBranchDialog = false;
    selectedDepartmentIdForMove: number | null = null;
    isChangingContractorCarrier = false;

    yesNoItems = [
        { text: this.$t("common.yes"), value: true },
        { text: this.$t("common.no"), value: false },
    ];

    rules = {
        locationId: [
            () => {
                const error = this.validationError.LocationId != undefined ? this.validationError.LocationId[0] : "";
                return error == "" || error;
            }],
        customerOrderId: [
            () => {
                const error = this.validationError.CustomerOrderId != undefined ? this.validationError.CustomerOrderId[0] : "";
                return error == "" || error;
            }],
        customerCompanyId: [
            () => {
                const error = this.validationError.CustomerCompanyId != undefined ? this.validationError.CustomerCompanyId[0] : "";
                return error == "" || error;
            }],
        customerContact: [
            () => {
                const error = this.validationError.CustomerContact != undefined ? this.validationError.CustomerContact[0] : "";
                return error == "" || error;
            }],
        customerContactPerson: [
            () => {
                const error = this.validationError.CustomerContactPerson != undefined ? this.validationError.CustomerContactPerson[0] : "";
                return error == "" || error;
            }],
        payerId: [
            () => {
                const error = this.validationError.PayerId != undefined ? this.validationError.PayerId[0] : "";
                return error == "" || error;
            }],
        driver1Name: [
            () => {
                const error = this.validationError.Driver1Name != undefined ? this.validationError.Driver1Name[0] : "";
                return error == "" || error;
            }],
        driver1Telephone: [
            () => {
                const error = this.validationError.Driver1Telephone != undefined ? this.validationError.Driver1Telephone[0] : "";
                return error == "" || error;
            }],
        orderId: [
            () => {
                const error = this.validationError.OrderId != undefined ? this.validationError.OrderId[0] : "";
                return error == "" || error;
            }],
        shippingCompanyId: [
            () => {
                const error = this.validationError.ShippingCompanyId != undefined ? this.validationError.ShippingCompanyId[0] : "";
                return error == "" || error;
            }
        ],
        registrationNumber: [
            () => {
                const error = this.validationError.RegistrationNumber != undefined ? this.validationError.RegistrationNumber[0] : "";
                return error == "" || error;
            }],
        saleValue: [
            () => {
                const error = this.validationError.SaleValue != undefined ? this.validationError.SaleValue[0] : "";
                return error == "" || error;
            }],
        saleValueCurrency: [
            () => {
                const error = this.validationError.SaleValueCurrency != undefined ? this.validationError.SaleValueCurrency[0] : "";
                return error == "" || error;
            }],
        paymentTermSale: [
            () => {
                const error = this.validationError.PaymentTermSale != undefined ? this.validationError.PaymentTermSale[0] : "";
                return error == "" || error;
            }],
        purchaseValue: [
            () => {
                const error = this.validationError.PurchaseValue != undefined ? this.validationError.PurchaseValue[0] : "";
                return error == "" || error;
            }],
        purchaseValueCurrency: [
            () => {
                const error = this.validationError.PurchaseValueCurrency != undefined ? this.validationError.PurchaseValueCurrency[0] : "";
                return error == "" || error;
            }],
        paymentTermPurchase: [
            () => {
                const error = this.validationError.PaymentTermPurchase != undefined ? this.validationError.PaymentTermPurchase[0] : "";
                return error == "" || error;
            }],
        placeName: [
            () => {
                const error = this.validationError.Name != undefined ? this.validationError.Name[0] : "";
                return error == "" || error;
            }],
        placeCountry: [
            () => {
                const error = this.validationError.Country != undefined ? this.validationError.Country[0] : "";
                return error == "" || error;
            }],
        placePostalCode: [
            () => {
                const error = (this.validationError.IsLocationConfirmedByUser != undefined) ? this.validationError.IsLocationConfirmedByUser[0] : "";
                return error == "" || error;
            },
            () => {
                const error = this.validationError.PostalCode != undefined ? this.validationError.PostalCode[0] : "";
                return error == "" || error;
            }],
        placeCity: [
            () => {
                const error = this.validationError.City != undefined ? this.validationError.City[0] : "";
                return error == "" || error;
            }
        ],
        placeWeight: [
            () => {
                const error = this.validationError.Weight != undefined ? this.validationError.Weight[0] : "";
                return error == "" || error;
            }],
        placeWeightUnit: [
            () => {
                const error = this.validationError.WeightUnit != undefined ? this.validationError.WeightUnit[0] : "";
                return error == "" || error;
            }],
        placeCount: [
            () => {
                const error = this.validationError.Count != undefined ? this.validationError.Count[0] : "";
                return error == "" || error;
            }],
        placeUnit: [
            () => {
                const error = this.validationError.Unit != undefined ? this.validationError.Unit[0] : "";
                return error == "" || error;
            }],
        planningDate: [
            () => {
                const error = this.validationError.Time != undefined ? this.validationError.Time[0] : "";
                return error == "" || error;
            }],
        whoPaysForCustomClearanceTypeId: [
            () => {
                const error = this.validationError.WhoPaysForCustomClearanceTypeId != undefined ? this.validationError.WhoPaysForCustomClearanceTypeId[0] : "";
                return error == "" || error;
            }],
        checkpointDescription: [
            () => {
                const error = this.validationError.Description != undefined ? this.validationError.Description[0] : "";
                return error == "" || error;
            }],
        checkpointCheckTime: [
            () => {
                const error = this.validationError.CheckTime != undefined ? this.validationError.CheckTime[0] : "";
                return error == "" || error;
            }],
        additionalDeclarationsComments: [
            () => {
                const error = this.validationError.AdditionalDeclarationsComments != undefined ? this.validationError.AdditionalDeclarationsComments[0] : "";
                return error == "" || error;
            }],
        numberOfKilometers: [
            () => {
                const error = this.validationError.NumberOfKilometers != undefined ? this.validationError.NumberOfKilometers[0] : "";
                return error == "" || error;
            }],
        vehicleType: [
            () => {
                const error = this.validationError.VehicleType != undefined ? this.validationError.VehicleType[0] : "";
                return error == "" || error;
            }],
        isADR: [
            () => {
                const error = this.validationError.IsADR != undefined ? this.validationError.IsADR[0] : "";
                return error == "" || error;
            }],
        kpiLifts: [
            () => {
                const error = this.validationError.KpiLifts != undefined ? this.validationError.KpiLifts[0] : "";
                return error == "" || error;
            }],
        tailLift: [
            () => {
                const error = this.validationError.TailLift != undefined ? this.validationError.TailLift[0] : "";
                return error == "" || error;
            }],
        extinguisher: [
            () => {
                const error = this.validationError.Extinguisher != undefined ? this.validationError.Extinguisher[0] : "";
                return error == "" || error;
            }],
        frigo: [
            () => {
                const error = this.validationError.Frigo != undefined ? this.validationError.Frigo[0] : "";
                return error == "" || error;
            }],
        sent: [
            () => {
                const error = this.validationError.Sent != undefined ? this.validationError.Sent[0] : "";
                return error == "" || error;
            }],
        isDedicatedTransport: [
            () => {
                const error = this.validationError.IsDedicatedTransport != undefined ? this.validationError.IsDedicatedTransport[0] : "";
                return error == "" || error;
            }],
        places: [
            () => {
                const error = this.validationError.Places != undefined ? this.validationError.Places[0] : "";
                return error == "" || error;
            }],
        specificGoodUnNumber: [
            (v: any) => {
                if (this.supervisor.isADR == true || this.supervisor.extinguisher == true) {
                    return (v !== null && v !== undefined && v > 0) || this.$t('common.validationErrorRequired');
                }
                return true;
            }
        ],
        specificGoodPackingGroup: [
            (v: any) => {
                if (this.supervisor.isADR == true || this.supervisor.extinguisher == true) {
                    return (v !== null && v !== undefined && v > 0) || this.$t('common.validationErrorRequired');
                }
                return true;
            }
        ],
        specificGoodNetWeight: [
            (v: any) => (v !== null && v !== undefined && v > 0) || this.$t('common.validationErrorRequired')
        ],
        specificGoodQuantity: [
            (v: any) => (v !== null && v !== undefined && v > 0) || this.$t('common.validationErrorRequired')
        ],
        specificGoodVin: [
            (v: any) => (v !== null && v !== undefined && v > 0) || this.$t('common.validationErrorRequired')
        ],
        specificGoodItem: [
            (v: any) => (v !== null && v !== undefined && v > 0) || this.$t('common.validationErrorRequired')
        ]
    };

    parseDecimal(value: string) {
        if (value === null || value === undefined || value === '') return null;
        const normalized = String(value).replace(',', '.');
        const parsed = parseFloat(normalized);
        return isNaN(parsed) ? null : parsed;
    }

    get isSupervisorInHistoricalState(): boolean {
        return this.$store.direct.state.supervisor.isSupervisorInHistoricalState;
    }

    set isSupervisorInHistoricalState(val: boolean) {
        this.$store.direct.commit.supervisor.setIsSupervisorInHistoricalState(val);
    }

    get attachmentList(): SupervisorAttachmentRestModel[] {
        return this.$store.direct.state.supervisor.attachmentList;
    }

    set attachmentList(value: SupervisorAttachmentRestModel[]) {
        this.$store.direct.commit.supervisor.setAttachmentList(value);
    }

    get procedureList(): SupervisorProcedureRestModel[] {
        return this.$store.direct.state.supervisor.procedureList;
    }

    set procedureList(value: SupervisorProcedureRestModel[]) {
        this.$store.direct.commit.supervisor.setProcedureList(value);
    }

    get vehicleTypes(): ListItemStringModel[] {
        return this.$store.direct.state.common.vehicleTypeListForSupervisor;
    }

    get transporeonIntegrationStates(): any[] {
        return this.$store.direct.state.transporeon.transporeonIntegrationStates;
    }

    get occurredErrorWhileSaving(): boolean {
        return this.$store.direct.state.supervisor.occurredErrorWhileSaving;
    }

    set occurredErrorWhileSaving(value: boolean) {
        this.$store.direct.commit.supervisor.setOccurredErrorWhileSaving(value);
    }

    get occurredErrorWhileSavingMessage(): string {
        return this.$store.direct.state.supervisor.occurredErrorWhileSavingMessage;
    }

    set occurredErrorWhileSavingMessage(value: string) {
        this.$store.direct.commit.supervisor.setOccurredErrorWhileSavingMessage(value);
    }

    get supervisorEditedByAnotherUser(): boolean {
        return this.$store.direct.state.supervisor.supervisorEditedByAnotherUser;
    }

    set supervisorEditedByAnotherUser(value: boolean) {
        this.$store.direct.commit.supervisor.setSupervisorEditedByAnotherUser(value);
    }

    get orderType(): ListItemNumberModel[] {
        return this.$store.direct.state.supervisor.supervisorPlaceOrderType;
    }

    get unitTypeArray(): string[] {
        return this.$store.direct.state.common.unitTypeArray;
    }

    get weightUnitTypeArray(): string[] {
        return this.$store.direct.state.common.weightUnitTypeArray;
    }

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get currentUserDepartments(): number[] {
        const currentUserDepartments = this.$store.direct.state.auth.currentUserDepartments;
        if (!currentUserDepartments.includes(this.currentUserDefaultDepartmentId)) {
            currentUserDepartments.push(this.currentUserDefaultDepartmentId);
        }
        return currentUserDepartments;
    }

    get departments(): ListItemNumberModel[] {
        const departments = this.$store.direct.state.contractor.contractorAssets.departments;
        if (departments != undefined) {
            if ((this.isEdited == false || this.userIsAdminOrUserCreatedOrder) || this.hangfireUserEmail == this.supervisor.createdByUserEmail) {
                const allowedDepartments = departments.filter((x: ListItemNumberModel) => {
                    if (this.currentUserDepartments.includes(x.value)) {
                        return x;
                    }
                });
                return allowedDepartments;
            }
            else {
                return departments;
            }
        }
        return [] as ListItemNumberModel[];
    }

    get moveToBranchDepartments(): ListItemNumberModel[] {
        const branches = this.$store.direct.state.register.userBranches as BranchRestModel[];
        if (branches == undefined || branches.length == 0) {
            return [] as ListItemNumberModel[];
        }
        return branches.flatMap((x: BranchRestModel) => {
            return (x.departments ?? []).map((department) => {
                return {
                    value: department.id,
                    text: `${x.name} - ${department.name}`,
                } as ListItemNumberModel;
            });
        });
    }

    get currentUserDefaultDepartmentId(): number {
        return this.$store.direct.state.auth.currentUserDefaultDepartmentId;
    }

    get currentUserRoles(): string[] {
        return this.$store.direct.state.auth.userRoles;
    }

    get hangfireUserEmail(): string {
        return this.$store.direct.state.common.hangfireUserEmail;
    }

    get allowEditContractorSenderFreightPaymentTermAndCurrency() {
        if (this.currentUserRoles.includes(Roles.Admin) || typeof (this.selectedContractorSender) == "string") {
            return true;
        }
        else if ((this.currentUserRoles.includes(Roles.DisponentAdmin) || this.currentUserRoles.includes(Roles.Accountant) || this.currentUserRoles.includes(Roles.AccountantAdmin)) && (this.supervisor.locationId == null || this.currentUserDepartments.includes(this.supervisor.locationId))) {
            return true;
        }
        return false;
    }

    get supervisor(): SupervisorRestModel {
        const supervisor = this.$store.direct.state.supervisor.supervisor as SupervisorRestModel;

        if (supervisor.isEditedByUserName != null) {
            this.supervisorIsEditedByAnotherUser = true;
            this.showSupervisorIsEditedByAnotherUserDialog(supervisor.isEditedByUserName);
        }

        if (supervisor.checkpoints != undefined) {
            supervisor.checkpoints = this.formatDateTime(supervisor.checkpoints, "checkTime");
        }
        if (supervisor.places != undefined) {
            supervisor.places = this.formatDateTime(supervisor.places, "time");
            supervisor.places = this.formatDateTime(supervisor.places, "timeTo");
            supervisor.places = this.formatDateTime(supervisor.places, "realTime");
        }
        if (this.currentSupervisorCheckpoints.length == 0) {
            this.currentSupervisorCheckpoints = supervisor.checkpoints != undefined ? supervisor.checkpoints : [];
        }
        if (this.currentSupervisorPlaces.length == 0) {
            this.currentSupervisorPlaces = supervisor.places != undefined ? supervisor.places : [];

            this.currentSupervisorPlaces.forEach((x: SupervisorPlaceRestModel) => {
                this.loadSupervisorPlaceAttachments(x);
            })
        }

        if (this.previousBranchId == undefined) {
            this.previousBranchId = this.contractorAssets.departments?.find((x: DepartmentItemRestModel) => { return x.value == this.defaultLocationId; })?.branchId
        }

        if (this.isSupervisorInHistoricalState) {
            this.defaultLocationId = supervisor.locationId;
        }

        if (supervisor.customerContactPerson != null && supervisor.customerContactPerson.value == 0 && this.contractorSenderDetailsForSupervisor.contactPersonList != undefined) {
            this.contractorSenderDetailsForSupervisor.contactPersonList.push({ text: supervisor.customerContactPerson.text, value: supervisor.customerContactPerson.value } as ListItemNumberModel)
        }

        this.loadSpecificGoodItemsFromSupervisorPlaces(supervisor.places);

        return supervisor;
    }

    get currentUserEmail(): string {
        return this.$store.direct.state.auth.currentUserEmail;
    }

    get userIsAdminOrUserCreatedOrder() {
        if (this.currentUserRoles.includes(Roles.Admin) || this.supervisor.createdByUserEmail == this.currentUserEmail) {
            return true;
        }
        return false;
    }

    get userIsAdminDisponentAdminOrDisponent(): boolean {
        return (this.currentUserRoles.includes(Roles.Admin) || this.currentUserRoles.includes(Roles.DisponentAdmin) || this.currentUserRoles.includes(Roles.Disponent)) ? true : false;
    }

    get showFreightCalculationForAccountingField(): boolean {
        return this.currentUserRoles.includes(Roles.AccountantAdmin) || this.currentUserRoles.includes(Roles.Admin) || this.currentUserRoles.includes(Roles.Accountant);
    }

    get supervisorPlace(): SupervisorPlaceRestModel {
        return this.$store.direct.state.supervisor.supervisorPlace;
    }

    get validationError(): any {
        return this.$store.direct.state.supervisor.validationError;
    }

    get contractorSenderDetailsForSupervisor(): ContractorDetailsForSupervisorRestModel {
        let contractorSenderDetailsForSupervisor = this.$store.direct.state.contractor.contractorSenderDetailsForSupervisor as ContractorDetailsForSupervisorRestModel;

        if (Object.keys(contractorSenderDetailsForSupervisor).length == 0) {
            contractorSenderDetailsForSupervisor = { id: 0, name: "", integrationEnabled: false, encoryIntegrationEnabled: false, kpiEnabled: false, requiresOriginalDocuments: false, departmentIdcs: [] as number[] } as ContractorDetailsForSupervisorRestModel;
        }
        else {
            this.integrationEnabled = contractorSenderDetailsForSupervisor.integrationEnabled;
            this.encoryIntegrationEnabled = contractorSenderDetailsForSupervisor.encoryIntegrationEnabled;
            this.kpiEnabled = contractorSenderDetailsForSupervisor.kpiEnabled;
        }

        if (contractorSenderDetailsForSupervisor.isLockedAsClient == true) {
            this.showContractorIsLockedAsClientDialog(contractorSenderDetailsForSupervisor)
            contractorSenderDetailsForSupervisor = { id: 0, name: "", integrationEnabled: false, encoryIntegrationEnabled: false, kpiEnabled: false, requiresOriginalDocuments: false, departmentIdcs: [] as number[] } as ContractorDetailsForSupervisorRestModel;
            this.contractorSenderSearch = "";
            this.selectedContractorSender = "" as any;
        }

        return contractorSenderDetailsForSupervisor;
    }

    set contractorSenderDetailsForSupervisor(val: ContractorDetailsForSupervisorRestModel) {
        this.$store.direct.commit.contractor.setContractorSenderDetailsForSupervisor(val);
    }

    get contractorCarrierDetailsForSupervisor(): ContractorDetailsForSupervisorRestModel {
        let contractorCarrierDetailsForSupervisor = this.$store.direct.state.contractor.contractorCarrierDetailsForSupervisor as ContractorDetailsForSupervisorRestModel;

        if (Object.keys(contractorCarrierDetailsForSupervisor).length == 0) {
            contractorCarrierDetailsForSupervisor = { id: 0, name: "", integrationEnabled: false, encoryIntegrationEnabled: false, kpiEnabled: false, departmentIdcs: [] as number[] } as ContractorDetailsForSupervisorRestModel;
        }

        if (this.isChangingContractorCarrier && contractorCarrierDetailsForSupervisor.isLockedAsCarrier == true) {
            this.showContractorIsLockedAsCarrierDialog(contractorCarrierDetailsForSupervisor)
            contractorCarrierDetailsForSupervisor = { id: 0, name: "", integrationEnabled: false, encoryIntegrationEnabled: false, kpiEnabled: false, departmentIdcs: [] as number[] } as ContractorDetailsForSupervisorRestModel;
            this.contractorCarrierSearch = ""
            this.selectedContractorCarrier = "" as any;
        }

        return contractorCarrierDetailsForSupervisor;
    }

    set contractorCarrierDetailsForSupervisor(val: ContractorDetailsForSupervisorRestModel) {
        this.$store.direct.commit.contractor.setContractorCarrierDetailsForSupervisor(val);
    }

    get contractorPayerDetailsForSupervisor(): ContractorDetailsForSupervisorRestModel {
        let contractorPayerDetailsForSupervisor = this.$store.direct.state.contractor.contractorPayerDetailsForSupervisor as ContractorDetailsForSupervisorRestModel;

        if (Object.keys(contractorPayerDetailsForSupervisor).length == 0) {
            contractorPayerDetailsForSupervisor = { id: 0, name: "", integrationEnabled: false, encoryIntegrationEnabled: false, kpiEnabled: false, departmentIdcs: [] as number[] } as ContractorDetailsForSupervisorRestModel;
        }

        if (contractorPayerDetailsForSupervisor.isLockedAsClient == true) {
            this.showContractorIsLockedAsClientDialog(contractorPayerDetailsForSupervisor)
            contractorPayerDetailsForSupervisor = { id: 0, name: "", integrationEnabled: false, encoryIntegrationEnabled: false, kpiEnabled: false, departmentIdcs: [] as number[] } as ContractorDetailsForSupervisorRestModel;
            this.contractorPayerSearch = ""
            this.selectedContractorPayer = "" as any;
        }

        return contractorPayerDetailsForSupervisor;
    }

    set contractorPayerDetailsForSupervisor(val: ContractorDetailsForSupervisorRestModel) {
        this.$store.direct.commit.contractor.setContractorPayerDetailsForSupervisor(val);
    }

    get userCanSeeContractorSenderAndHisFreightDetails(): boolean {
        if (this.contractorSenderDetailsForSupervisor.disableField == true) {
            return false;
        };

        if (this.currentUserRoles.includes(Roles.Admin)
            || this.supervisor.locationId == null
            || this.currentUserDepartments.includes(this.supervisor.locationId)) {
            return true;
        }

        return false;
    }

    get userCanSeeContractorCarrierAndHisFreightDetails(): boolean {
        if (this.contractorCarrierDetailsForSupervisor.disableField == true) {
            return false;
        };

        if (this.currentUserRoles.includes(Roles.Admin)
            || this.supervisor.locationId == null
            || this.currentUserDepartments.includes(this.supervisor.locationId)) {
            return true;
        }

        return false;
    }

    get selectedContractorSender(): ContractorSearchItemModel {
        const selectedContractorSender = this.$store.direct.state.supervisor.selectedContractorSender;
        if (selectedContractorSender != null && selectedContractorSender.text != undefined && selectedContractorSender.text && selectedContractorSender.value == 0) {
            this.contractorSenderFound.push({ text: selectedContractorSender.text, value: 0, additionalInfo: "" } as ContractorSearchItemModel);
        }
        if (selectedContractorSender != null && selectedContractorSender.value != undefined && selectedContractorSender.value != 0) {
            this.contractorSenderFound.push({ text: selectedContractorSender.text, value: selectedContractorSender.value, additionalInfo: selectedContractorSender.additionalInfo } as ContractorSearchItemModel);
            this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: selectedContractorSender.value, contractorType: ContractorTypes.Client })
        }
        if (selectedContractorSender != null && selectedContractorSender.value == undefined) {
            this.integrationEnabled = false;
            this.encoryIntegrationEnabled = false;
            this.kpiEnabled = false;
        }
        return selectedContractorSender;
    }

    set selectedContractorSender(val: ContractorSearchItemModel) {
        this.$store.direct.commit.supervisor.setSelectedContractorSender(val);
    }

    get selectedContractorCarrier(): ContractorSearchItemModel {
        const selectedContractorCarrier = this.$store.direct.state.supervisor.selectedContractorCarrier;
        if (selectedContractorCarrier != null && selectedContractorCarrier.text != undefined && selectedContractorCarrier.text && selectedContractorCarrier.value == 0) {
            this.contractorCarrierFound.push({ text: selectedContractorCarrier.text, value: 0, additionalInfo: "" } as ContractorSearchItemModel);
        }
        if (selectedContractorCarrier != null && selectedContractorCarrier.value != undefined && selectedContractorCarrier.value != 0) {
            this.contractorCarrierFound.push({ text: selectedContractorCarrier.text, value: selectedContractorCarrier.value, additionalInfo: selectedContractorCarrier.additionalInfo } as ContractorSearchItemModel);
            this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: selectedContractorCarrier.value, contractorType: ContractorTypes.Carrier })
        }
        return selectedContractorCarrier;
    }

    set selectedContractorCarrier(val: ContractorSearchItemModel) {
        this.$store.direct.commit.supervisor.setSelectedContractorCarrier(val);
    }

    get selectedContractorPayer(): ContractorSearchItemModel {
        const selectedContractorPayer = this.$store.direct.state.supervisor.selectedContractorPayer;
        if (selectedContractorPayer != null && selectedContractorPayer.text != undefined && selectedContractorPayer.text && selectedContractorPayer.value == 0) {
            this.contractorPayerFound.push({ text: selectedContractorPayer.text, value: 0, additionalInfo: "" } as ContractorSearchItemModel);
        }
        if (selectedContractorPayer != null && selectedContractorPayer.value != undefined && selectedContractorPayer.value != 0) {
            this.contractorPayerFound.push({ text: selectedContractorPayer.text, value: selectedContractorPayer.value, additionalInfo: selectedContractorPayer.additionalInfo } as ContractorSearchItemModel);
            this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: selectedContractorPayer.value, contractorType: ContractorTypes.Payer })
        }
        if (selectedContractorPayer != null && selectedContractorPayer.value == undefined) {
            this.integrationEnabled = false;
            this.encoryIntegrationEnabled = false;
            this.kpiEnabled = false;
        }
        return selectedContractorPayer;
    }

    set selectedContractorPayer(val: ContractorSearchItemModel) {
        this.$store.direct.commit.supervisor.setSelectedContractorPayer(val);
    }

    get contractorSenderFound(): ContractorSearchItemModel[] {
        return this.$store.direct.state.supervisor.contractorSenderFound;
    }

    get contractorCarrierFound(): ContractorSearchItemModel[] {
        return this.$store.direct.state.supervisor.contractorCarrierFound;
    }

    get contractorPayerFound(): ContractorSearchItemModel[] {
        return this.$store.direct.state.supervisor.contractorPayerFound;
    }

    get showAddContractorCarrierButton(): boolean {
        if (this.contractorCarrierFound.length == 0
            && this.contractorCarrierSearch
            && this.userCanSeeContractorCarrierAndHisFreightDetails) {
            return true;
        }
        return false;
    }

    get showEditContractorCarrierButton(): boolean {
        if (this.contractorCarrierFound.length > 0
            && this.selectedContractorCarrier != null
            && this.selectedContractorCarrier.value != undefined
            && this.selectedContractorCarrier.value != 0
            && this.userCanSeeContractorCarrierAndHisFreightDetails) {
            return true;
        }
        return false;
    }

    get showAddContractorSenderButton(): boolean {
        if (this.contractorSenderFound.length == 0
            && this.contractorSenderSearch
            && this.userCanSeeContractorSenderAndHisFreightDetails
            && (this.currentUserRoles.includes(Roles.Admin) || this.currentUserRoles.includes(Roles.DisponentAdmin))) {
            return true;
        }
        return false;
    }

    get showEditContractorSenderButton(): boolean {
        if (this.contractorSenderFound.length > 0
            && this.userCanSeeContractorSenderAndHisFreightDetails
            && this.selectedContractorSender != null
            && this.selectedContractorSender.value != undefined
            && this.selectedContractorSender.value != 0
            && (this.currentUserRoles.includes(Roles.Admin) || this.currentUserRoles.includes(Roles.DisponentAdmin))) {
            return true;
        }
        return false;
    }

    get placeNamesFound(): SupervisorPlaceRestModel[] {
        return this.$store.direct.state.supervisor.supervisorPlaceNamesFound;
    }

    set placeNamesFound(val: SupervisorPlaceRestModel[]) {
        this.$store.direct.commit.supervisor.setSupervisorPlaceNamesFound(val);
    }

    get placeCitiesFound(): SupervisorPlaceRestModel[] {
        return this.$store.direct.state.supervisor.supervisorPlaceCitiesFound;
    }

    get placePostalCodesFound(): SupervisorPlaceRestModel[] {
        return this.$store.direct.state.supervisor.supervisorPlacePostalCodesFound;
    }

    get checkIfContractorPolicyIsActive(): boolean {
        return this.$store.direct.state.contractor.checkIfContractorPolicyIsActive;
    }

    get checkIfContractorClientHasExceededDebtLimit(): boolean {
        return this.$store.direct.state.contractor.checkIfContractorClientHasExceededDebtLimit;
    }

    get checkIfContractorPayerHasExceededDebtLimit(): boolean {
        return this.$store.direct.state.contractor.checkIfContractorPayerHasExceededDebtLimit;
    }

    get isDroppedFromPreliminaryList(): boolean {
        return this.$store.direct.state.supervisor.isDroppedFromPreliminaryList;
    }

    get supervisorMementoListCount(): number {
        const supervisorMementoListCount = this.$store.direct.state.supervisor.supervisorMementoListCount - 1;
        this.lastSupervisorMementoPoint = supervisorMementoListCount;
        this.supervisorMementoSelectedPoint = supervisorMementoListCount;
        return supervisorMementoListCount;
    }

    get supervisorMementoList(): SupervisorMementoItemRestModel[] {
        return this.$store.direct.state.supervisor.supervisorMementoList;
    }

    get disableSupervisorMementoSwitch(): boolean {
        return this.supervisorMementoListCount < 1 ? true : false;
    }

    get addressFound() {
        if (this.$store.direct.state.common.addressFound == null) {
            return [];
        }
        return this.$store.direct.state.common.addressFound;
    }

    get currencies(): CurrencyRestModel[] {
        return this.$store.direct.state.contractor.contractorAssets.currencies;
    }

    get backToSupervisorArchiveListForSettlement(): boolean {
        return this.$store.direct.state.supervisorForSettlement.backToSupervisorArchiveListForSettlement;
    }

    set backToSupervisorArchiveListForSettlement(val: boolean) {
        this.$store.direct.commit.supervisorForSettlement.setBackToSupervisorArchiveListForSettlement(val);
    }

    get backToSupervisorAllOrdersList(): boolean {
        return this.$store.direct.state.supervisorAllOrders.backToSupervisorAllOrdersList;
    }

    set backToSupervisorAllOrdersList(val: boolean) {
        this.$store.direct.commit.supervisorAllOrders.setBackToSupervisorAllOrdersList(val);
    }

    get isSupervisorCopied(): boolean {
        return this.$store.direct.state.supervisor.isSupervisorCopied;
    }

    set isSupervisorCopied(val: boolean) {
        this.$store.direct.commit.supervisor.setIsSupervisorCopied(val);
    }

    get supervisorBaseToCopy(): SupervisorRestModel {
        return this.$store.direct.state.supervisor.supervisorBaseToCopy;
    }

    set supervisorBaseToCopy(val: SupervisorRestModel) {
        this.$store.direct.commit.supervisor.setSupervisorBaseToCopy(val);
    }

    get disableSaveSupervisorDueToPossessionOfCostOrIncomeDocuments(): boolean {
        const result = (!this.currentUserRoles.includes(Roles.Admin) && !this.currentUserRoles.includes(Roles.AccountantAdmin) && !this.currentUserRoles.includes(Roles.Accountant)) && this.supervisor.hasCostOrIncomeDocumentsAssigned;
        return result;
    }

    get disableSaveSupervisorDueToCloneRelation(): boolean {
        if (!this.hasOriginalSupervisorId) return false;

        if (this.currentUserRoles.includes(Roles.Admin)
            || this.currentUserRoles.includes(Roles.AccountantAdmin)
            || this.currentUserRoles.includes(Roles.Accountant))
            return false;

        return true;
    }

    get hasOriginalSupervisorId(): boolean {
        return this.supervisor.originalSupervisorId != null && this.supervisor.originalSupervisorId != undefined;
    }

    get clonedSupervisorList(): ListItemNumberModel[] {
        return this.$store.direct.state.supervisor.clonedSupervisorList;
    }

    get showGoToClonedSupervisorList(): boolean {
        return !this.hasOriginalSupervisorId && this.clonedSupervisorList.length > 0;
    }

    get disableSaveAndSendSupervisorCarrierDocumentEmail(): boolean {
        return this.isLoading
            || this.supervisor.isPreliminary
            || this.isSupervisorInHistoricalState
            || this.disableSaveSupervisorDueToPossessionOfCostOrIncomeDocuments
            || this.disableSaveSupervisorDueToCloneRelation
            || this.supervisorIsEditedByAnotherUser
            || !this.enableSaveSupervisorOnlyForAdminAndAccountantAdminIfSupervisorsHasAnyCostOrIncomeDocumetWhichHasCorrection;
    }

    get showSendSupervisorCarrierDocumentEmailWithoutSaving(): boolean {
        return this.hasOriginalSupervisorId
            && this.disableSaveSupervisorDueToCloneRelation
            && this.disableSaveAndSendSupervisorCarrierDocumentEmail;
    }

    get enableSaveSupervisorOnlyForAdminAndAccountantAdminIfSupervisorsHasAnyCostOrIncomeDocumetWhichHasCorrection(): boolean {
        const result = (this.currentUserRoles.includes(Roles.Admin) || this.currentUserRoles.includes(Roles.AccountantAdmin)) || !this.supervisor.hasAnyCostOrIncomeDocumentsWhichHasCorrection;
        return result;
    }

    get contractorAssets(): ContractorAssetsRestModel {
        return this.$store.direct.state.contractor.contractorAssets;
    }

    get localStorageApplicationStateData(): LocalStorageApplicationStateDataModel {
        return this.$store.direct.state.common.localStorageApplicationStateData;
    }

    get isSupervisorCompletedOrder(): boolean {
        return !this.supervisor.isPreliminary;
    }

    set isSupervisorCompletedOrder(val: boolean) {
        this.supervisor.isPreliminary = !val;
    }

    get registrationNumberLabel() {
        this.supervisorBaseToCopy.registrationNumber = this.supervisorBaseToCopy.registrationNumber == null ? "" : this.supervisorBaseToCopy.registrationNumber;
        return this.isFullDuplicating ? `${this.$t("supervisor.registrationNumber")}` + ' - ' + this.supervisorBaseToCopy.registrationNumber : `${this.$t("supervisor.registrationNumber")}`
    }

    get driver1NameLabel() {
        this.supervisorBaseToCopy.driver1Name = this.supervisorBaseToCopy.driver1Name == null ? "" : this.supervisorBaseToCopy.driver1Name;
        return this.isFullDuplicating ? `${this.$t("supervisor.driverName")}` + ' - ' + this.supervisorBaseToCopy.driver1Name : `${this.$t("supervisor.driverName")}`
    }

    get driver1TelephoneLabel() {
        this.supervisorBaseToCopy.driver1Telephone = this.supervisorBaseToCopy.driver1Telephone == null ? "" : this.supervisorBaseToCopy.driver1Telephone;
        return this.isFullDuplicating ? `${this.$t("supervisor.driverTelephone")}` + ' - ' + this.supervisorBaseToCopy.driver1Telephone : `${this.$t("supervisor.driverTelephone")}`
    }

    get driver2NameLabel() {
        this.supervisorBaseToCopy.driver2Name = this.supervisorBaseToCopy.driver2Name == null ? "" : this.supervisorBaseToCopy.driver2Name;
        return this.isFullDuplicating ? `${this.$t("supervisor.driverName2")}` + ' - ' + this.supervisorBaseToCopy.driver2Name : `${this.$t("supervisor.driverName2")}`
    }

    get driver2TelephoneLabel() {
        this.supervisorBaseToCopy.driver2Telephone = this.supervisorBaseToCopy.driver2Telephone == null ? "" : this.supervisorBaseToCopy.driver2Telephone;
        return this.isFullDuplicating ? `${this.$t("supervisor.driverTelephone2")}` + ' - ' + this.supervisorBaseToCopy.driver2Telephone : `${this.$t("supervisor.driverTelephone2")}`
    }

    get transEuFreight(): TransEuFreightRestModel {
        return this.$store.direct.state.freightExchange.transEuFreight;
    }

    set transEuFreight(val: TransEuFreightRestModel) {
        this.$store.direct.commit.freightExchange.setTransEuFreight(val);
    }

    get courierNetFreight(): CourierNetFreightRestModel {
        return this.$store.direct.state.freightExchange.courierNetFreight;
    }

    set courierNetFreight(val: CourierNetFreightRestModel) {
        this.$store.direct.commit.freightExchange.setCourierNetFreight(val);
    }

    get currentSupervisorLoadingPlaceId(): undefined | number {
        return this.$store.direct.state.supervisorTransportDocument.currentSupervisorLoadingPlaceId;
    }

    set currentSupervisorLoadingPlaceId(val: undefined | number) {
        this.$store.direct.commit.supervisorTransportDocument.setCurrentSupervisorLoadingPlaceId(val);
    }

    get currentSupervisorUnloadingPlaceId(): undefined | number {
        return this.$store.direct.state.supervisorTransportDocument.currentSupervisorUnloadingPlaceId;
    }

    set currentSupervisorUnloadingPlaceId(val: undefined | number) {
        this.$store.direct.commit.supervisorTransportDocument.setCurrentSupervisorUnloadingPlaceId(val);
    }

    get selectedPlacesIdcsForCreatingNewSupervisor(): (number | undefined)[] {
        return this.currentSupervisorPlaces.filter((x: SupervisorPlaceRestModel) => x.isCheckedForCreatingNewSupervisor == true).map(x => x.id);
    }

    get contractorTags(): ListItemNumberModel[] {
        return this.$store.direct.state.contractor.contractorAssets.contractorTags
    }

    get selectedContractorCarrierTagListForFilter(): ListItemNumberModel[] {
        return this.$store.direct.state.contractor.selectedContractorCarrierTagListForFilter;
    }

    set selectedContractorCarrierTagListForFilter(val: ListItemNumberModel[]) {
        this.$store.direct.commit.contractor.setSelectedContractorCarrierTagListForFilter(val);
    }

    get sendingSmsDialogPhoneNumber(): string {
        return this.$store.direct.state.supervisor.sendingSmsDialogPhoneNumber;
    }

    set sendingSmsDialogPhoneNumber(val: string) {
        this.$store.direct.commit.supervisor.setSendingSmsDialogPhoneNumber(val);
    }

    get contractorCarrierEmailList(): ListItemNumberModel[] {
        return this.$store.direct.state.contractor.emailAddressList;
    }

    set contractorCarrierEmailList(val: ListItemNumberModel[]) {
        this.$store.direct.commit.contractor.setEmailAddressList(val);
    }

    get supervisorProjectFerryChargesCountries(): CountryRestModel[] {
        return this.$store.direct.state.supervisor.supervisorAssets.supervisorProjectFerryChargesCountries;
    }

    get teamItems(): ListItemNumberModel[] {
        return this.$store.direct.state.supervisor.supervisorAssets?.teams ?? [];
    }

    get selectedSupervisorTeamId(): number | null {
        return this.supervisor.teamIds != null && this.supervisor.teamIds.length > 0
            ? this.supervisor.teamIds[0]
            : null;
    }

    set selectedSupervisorTeamId(value: number | null) {
        this.supervisor.teamIds = value != null ? [value] : [];
    }

    get showMoveToMarwayPlButton(): boolean {
        const assets = this.$store.direct.state.supervisor.supervisorAssets;
        if (!assets || !assets.departmentIdcsForMarwayDe) return false;
        const locationIsMarwayDe = this.defaultLocationId != null && assets.departmentIdcsForMarwayDe.includes(this.defaultLocationId);
        const carrierIsNotMarwayPl = this.selectedContractorCarrier == null || this.selectedContractorCarrier.value !== assets.marwayPlContractorId;
        const currencyIdEur = this.supervisor.purchaseValueCurrency == "EUR" && this.supervisor.saleValueCurrency == "EUR";
        return !this.supervisor.isPreliminary && locationIsMarwayDe && carrierIsNotMarwayPl && currencyIdEur;
    }

    get transportDocumentTypeList(): ListItemNumberModel[] {
        return this.$store.direct.state.supervisorEncory.transportDocumentTypeList;
    }

    get supervisorPlaceSpecificGoodItemFound(): SupervisorPlaceSpecificGoodItemRestModel[] {
        const searchResults = this.$store.direct.state.supervisor.supervisorPlaceSpecificGoodItemSearch || [];
        const combined = [...this.supervisorPlaceSpecificGoodItemsFromPlaces];

        searchResults.forEach((item: SupervisorPlaceSpecificGoodItemRestModel) => {
            const exists = combined.some(x => x.id === item.id);
            if (!exists) {
                combined.push(item);
            }
        });

        this.currentSupervisorPlaces.forEach((place: SupervisorPlaceRestModel) => {
            if (place.specificGoods && place.specificGoods.length > 0) {
                place.specificGoods.forEach((good: SupervisorPlaceSpecificGoodRestModel) => {
                    if (good.specificGoodItemId && good.specificGoodItemName) {
                        const exists = combined.some(x => x.id === good.specificGoodItemId);
                        if (!exists) {
                            combined.push({
                                id: good.specificGoodItemId,
                                name: good.specificGoodItemName,
                            } as SupervisorPlaceSpecificGoodItemRestModel);
                        }
                    }
                });
            }
        });

        return combined;
    }

    get specificGoodUnNumbers(): SupervisorPlaceSpecificGoodUnNumberRestModel[] {
        return this.$store.direct.state.supervisor.specificGoodUnNumbers || [];
    }

    get specificGoodPackingGroups(): SupervisorPlaceSpecificGoodPackingGroupRestModel[] {
        return this.$store.direct.state.supervisor.specificGoodPackingGroups || [];
    }

    get bmwCustomerIdcs(): number[] {
        return this.$store.direct.state.contractor.contractorAssets.bmwCustomerIdcs
    }

    get countryList(): CountryRestModel[] {
        return this.$store.direct.state.contractor.contractorAssets.countries;
    }

    @Watch("contractorSenderSearch")
    contractorSenderSearchLoadItems(val: string) {
        this.$store.direct.dispatch.common.searchContractors({ searchText: val, contractorTypes: [ContractorTypes.Client], contractorPropertiesEnabled: [], source: "supervisor", searchOnlyActive: true });
    }

    @Watch("contractorCarrierSearch")
    contractorCarrierSearchLoadItems(val: string) {
        this.$store.direct.dispatch.common.searchContractors({ searchText: val, contractorTypes: [ContractorTypes.Carrier], contractorPropertiesEnabled: [], source: "supervisor", searchOnlyActive: true });
    }

    @Watch("contractorPayerSearch")
    contractorPayerSearchLoadItems(val: string) {
        this.$store.direct.dispatch.common.searchContractors({ searchText: val, contractorTypes: [ContractorTypes.Payer], contractorPropertiesEnabled: [], source: "supervisor", searchOnlyActive: true });
    }

    @Watch("validationError.Places")
    async validationErrorPlacesHandler(val: any) {
        if (this.validationError.Places == undefined) {
            this.placesError = null;
        }
        else {
            this.placesError = this.validationError.Places[0];
        }
    }

    @Watch("supervisor.isPayerRequired")
    async supervisorIsPayerRequiredHandler(val: any) {
        if (this.supervisor.isPayerRequired == false) {
            this.selectedContractorPayer = { text: "", value: 0, contractorSymbol: "", additionalInfo: "" };
        }
    }

    @Watch("localStorageApplicationStateData", { deep: true })
    localStorageApplicationStateDataHandles() {
        this.$store.direct.dispatch.common.updateLocalStorageApplicationStateData();
        if (!this.localStorageApplicationStateData.supervisorEditingIsPlaceSuggestionsOn) {
            this.placeNamesFound = [] as SupervisorPlaceRestModel[]
        }
    }

    @Watch("supervisor.orderId")
    supervisorOrderIdChanged() {
        this.setBrowserTabTitle();
    }

    setBrowserTabTitle() {
        const orderId = this.supervisor.orderId != null ? this.supervisor.orderId.toString().trim() : "";
        document.title = orderId.length > 0
            ? `${orderId} - ${this.$store.direct.state.common.tabTitle}`
            : this.$store.direct.state.common.tabTitle;
    }

    specificGoodItemSearch(good: SupervisorPlaceSpecificGoodRestModel, placeIndex: number, goodIndex: number) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            if (good.searchText && good.searchText.length >= 2) {
                this.$store.direct.dispatch.supervisor.searchSupervisorPlaceSpecificGoodItems({
                    searchText: good.searchText
                });
            }
        }, 1000);
    }

    getSupervisorMementoItem(value: number): SupervisorMementoItemRestModel {
        if (value > -1 && this.supervisorMementoList.length > 0) {
            return this.supervisorMementoList[value];
        }
        return {} as SupervisorMementoItemRestModel;
    }

    setSupervisorPlacesChackpointCurrentPlacesCurrentCheckpointAsEmpty() {
        this.supervisor.checkpoints = [] as SupervisorCheckpointRestModel[];
        this.supervisor.places = [] as SupervisorPlaceRestModel[];
        this.currentSupervisorCheckpoints = [] as SupervisorCheckpointRestModel[];
        this.currentSupervisorPlaces = [] as SupervisorPlaceRestModel[];
    }

    allowNumbersOnly(evt: any) {
        return this.$store.direct.dispatch.settlementCommon.allowNumbersOnly(evt);
    }

    async supervisorMementoPointChanged(historyPoint: number) {
        if (historyPoint != this.lastSupervisorMementoPoint) {
            this.setSupervisorPlacesChackpointCurrentPlacesCurrentCheckpointAsEmpty();

            if (historyPoint >= 0) {
                this.isSupervisorInHistoricalState = true;
                await this.$store.direct.dispatch.supervisor.getSupervisorMementoPoint({ mementoPoint: historyPoint });
                await this.$store.direct.dispatch.supervisor.loadSupervisorAttachmentList({ mementoPoint: historyPoint });
            }
            this.lastSupervisorMementoPoint = historyPoint;
        }
    }

    async selectedContractorSenderChanged() {
        if (typeof (this.selectedContractorSender) != "string" && this.selectedContractorSender != null) {
            await this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: this.selectedContractorSender.value, contractorType: ContractorTypes.Client })

            if (this.contractorSenderDetailsForSupervisor.specialInfo != null && this.contractorSenderDetailsForSupervisor.specialInfo != undefined && this.contractorSenderDetailsForSupervisor.specialInfo != "") {
                this.$store.direct.dispatch.confirm
                    .openConfirmDialog({
                        showConfirmDialog: true,
                        title: `${this.$t("contractor.specialInfo")}`,
                        message: this.contractorSenderDetailsForSupervisor.specialInfo,
                        links: [],
                        options: { buttonColor: "primary", layoutColor: "primary" },
                        buttonType: "ok"
                    })
                    .then(async confirm => {
                        if (confirm) {
                            this.occurredErrorWhileSaving = false;
                        }
                    });
            }

            if (!this.supervisor.isPayerRequired) {
                this.supervisor.saleValueCurrency = this.contractorSenderDetailsForSupervisor.saleValueCurrency;
                this.supervisor.paymentTermSale = this.contractorSenderDetailsForSupervisor.paymentTermSale;

                this.supervisor.isPayerRequired = this.contractorSenderDetailsForSupervisor.isPayerRequired;
            }

            if (this.contractorSenderDetailsForSupervisor.contractorPayerId) {
                this.supervisor.isPayerRequired = true;

                const payerItem = {
                    value: this.contractorSenderDetailsForSupervisor.contractorPayerId,
                    text: this.contractorSenderDetailsForSupervisor.contractorPayerNameAndSymbol,
                    contractorSymbol: "",
                    additionalInfo: "",
                } as ContractorSearchItemModel;

                this.selectedContractorPayer = payerItem;

                await this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({
                    contractorId: this.contractorSenderDetailsForSupervisor.contractorPayerId,
                    contractorType: ContractorTypes.Payer
                });
            }
        }
    }

    async selectedContractorCarrierChanged() {
        if (typeof (this.selectedContractorCarrier) != "string" && this.selectedContractorCarrier != null) {
            this.isChangingContractorCarrier = true;
            await this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: this.selectedContractorCarrier.value, contractorType: ContractorTypes.Carrier })
            this.isChangingContractorCarrier = false;

            this.supervisor.shippingCompanyTags = this.contractorCarrierDetailsForSupervisor.tagsForSupervisor;

            if (this.contractorCarrierDetailsForSupervisor.specialInfo != null && this.contractorCarrierDetailsForSupervisor.specialInfo != undefined) {
                this.$store.direct.dispatch.confirm
                    .openConfirmDialog({
                        showConfirmDialog: true,
                        title: `${this.$t("contractor.specialInfo")}`,
                        message: this.contractorCarrierDetailsForSupervisor.specialInfo,
                        links: [],
                        options: { buttonColor: "primary", layoutColor: "primary" },
                        buttonType: "ok"
                    })
                    .then(async confirm => {
                        if (confirm) {
                            this.occurredErrorWhileSaving = false;
                        }
                    });
            }

            this.supervisor.purchaseValueCurrency = this.contractorCarrierDetailsForSupervisor.purchaseValueCurrency;
            this.supervisor.paymentTermPurchase = this.contractorCarrierDetailsForSupervisor.paymentTermPurchase;

            await this.checkIfContractorCarrierPolicyIsActive();
        }
    }

    async selectedContractorPayerChanged() {
        if (typeof (this.selectedContractorPayer) != "string" && this.selectedContractorPayer != null) {
            await this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: this.selectedContractorPayer.value, contractorType: ContractorTypes.Payer })

            if (this.contractorPayerDetailsForSupervisor.specialInfo != null && this.contractorPayerDetailsForSupervisor.specialInfo != undefined) {
                this.$store.direct.dispatch.confirm
                    .openConfirmDialog({
                        showConfirmDialog: true,
                        title: `${this.$t("contractor.specialInfo")}`,
                        message: this.contractorPayerDetailsForSupervisor.specialInfo,
                        links: [],
                        options: { buttonColor: "primary", layoutColor: "primary" },
                        buttonType: "ok"
                    })
                    .then(async confirm => {
                        if (confirm) {
                            this.occurredErrorWhileSaving = false;
                        }
                    });
            }

            this.supervisor.saleValueCurrency = this.contractorPayerDetailsForSupervisor.saleValueCurrency;
            this.supervisor.paymentTermSale = this.contractorPayerDetailsForSupervisor.paymentTermSale;
        }
    }

    @Watch("currentSupervisorPlaces", { deep: true })
    currentSupervisorPlacesHandler() {
        if (this.isEdited == false && this.currentSupervisorPlaces.length >= 2) {
            const firstPlace = this.currentSupervisorPlaces[0];
            const secondPlace = this.currentSupervisorPlaces[1];

            if (this.currentSupervisorPlaces.length == 2 && firstPlace.typeId == 1 && secondPlace.typeId == 2) {

                if (firstPlace.count != undefined) {
                    secondPlace.count = "-" + firstPlace.count;
                    secondPlace.unit = firstPlace.unit;
                }
                if (firstPlace.weight != undefined) {
                    secondPlace.weight = "-" + firstPlace.weight;
                    secondPlace.weightUnit = firstPlace.weightUnit;
                }
            }
            else if (firstPlace.typeId == 1 && this.currentSupervisorPlaces.slice(1).every((x: SupervisorPlaceRestModel) => { return x.typeId == 2 })) {
                const placeCountArray = [] as number[];
                const placeWeightArray = [] as number[];

                const placesWithoutFirstAndLast = this.currentSupervisorPlaces.slice(1, -1);
                placesWithoutFirstAndLast.forEach((x: SupervisorPlaceRestModel) => {
                    placeCountArray.push(Math.abs(Number(x.count)));
                    placeWeightArray.push(Math.abs(Number(x.weight)));

                    x.unit = firstPlace.unit;
                    x.weightUnit = firstPlace.weightUnit;
                })

                const lastPlace = this.currentSupervisorPlaces[this.currentSupervisorPlaces.length - 1];
                lastPlace.unit = firstPlace.unit;
                lastPlace.weightUnit = firstPlace.weightUnit;

                const everyElementInPlaceCountArrayIsNumber = placeCountArray.every((x: any) => {
                    return !isNaN(x);
                });
                if (everyElementInPlaceCountArrayIsNumber == true && !isNaN(Number(firstPlace.count))) {
                    lastPlace.count = "-" + (Number(firstPlace.count) - placesWithoutFirstAndLast.reduce((sum: number, current: SupervisorPlaceRestModel) => sum + Math.abs(Number(current.count)), 0)).toString();
                }

                const everyElementInPlaceWeightArrayIsNumber = placeWeightArray.every((x: any) => {
                    return !isNaN(x);
                });
                if (everyElementInPlaceWeightArrayIsNumber == true && !isNaN(Number(firstPlace.weight))) {
                    lastPlace.weight = "-" + (Number(firstPlace.weight) - placesWithoutFirstAndLast.reduce((sum: number, current: SupervisorPlaceRestModel) => sum + Math.abs(Number(current.weight)), 0)).toString();
                }
            }
        }
    }

    async supervisorPlacePlanningDateChanged(place: SupervisorPlaceRestModel, index: number) {
        this.getCloseUnloadingsForLoading(place);
        this.supervisorPlaceCountryChanged(place, index);
    }

    async getCloseUnloadingsForLoading(place: SupervisorPlaceRestModel) {
        if (place.typeId == 1) {
            place.closePlaceTimeAndDistanceComment = await this.$store.direct.dispatch.supervisor.getCloseUnloadingsForLoading({ place: place }) as string;
            this.$forceUpdate();
        }
    }

    async onNonConformityClick() {
        if (this.supervisor.isArchived
            && this.currentUserRoles.includes(Roles.DisponentAdmin)
            && !(this.currentUserRoles.includes(Roles.Admin) || this.currentUserRoles.includes(Roles.AccountantAdmin)))
            this.$store.direct.dispatch.supervisor.openNcEditDialog();
    };

    @Watch("occurredErrorWhileSaving")
    occurredErrorWhileSavingHandle(val: boolean) {
        if (val == true) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("common.errorWhileSaving")}`,
                    message: this.occurredErrorWhileSavingMessage,
                    links: [],
                    options: { buttonColor: "white", layoutColor: "error" },
                    buttonType: "ok"
                })
                .then(async confirm => {
                    if (confirm) {
                        this.occurredErrorWhileSaving = false;
                    }
                });
        }
    }

    @Watch("supervisorEditedByAnotherUser")
    supervisorEditedByAnotherUserHandle(val: boolean) {
        if (val == true) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("supervisor.supervisorEditedByAnotherUserTitle")}`,
                    message: `${this.$t("supervisor.supervisorEditedByAnotherUserMessage")}`,
                    links: [],
                    options: { buttonColor: "white", layoutColor: "error" },
                    buttonType: "ok"
                })
                .then(async confirm => {
                    if (confirm) {
                        this.supervisorEditedByAnotherUser = false;
                    }
                });
        }
    }

    @Watch("defaultLocationId")
    async defaultLocationIdHandle(val: number) {
        const currentBranchId = this.contractorAssets.departments.find((x: DepartmentItemRestModel) => {
            return x.value == this.defaultLocationId;
        })?.branchId;

        if (this.previousBranchId != currentBranchId && !this.isSupervisorInHistoricalState) {
            this.supervisor.locationId = this.defaultLocationId;
            await this.assignSupervisorOrderIdDueToBranchChanged(currentBranchId);
        }
    }

    @Watch("supervisor.isEditedByUserName", { deep: true })
    supervisorIsEditedByUserNameHandle(val: boolean) {
        if (this.supervisor.isEditedByUserName != null) {
            this.clearSupervisorLockedForEditingUntilValue();
        }
        else {
            this.updateSupervisorLockedForEditingUntilValue();
        }
    }

    @Watch("supervisor.saleValue")
    supervisorSaleValueHandler(newVal: any, oldVal: any) {
        if (!this.supervisorInitialized) return;
        if (newVal === undefined || newVal === null) return;

        const parsedNew = parseFloat(newVal.toString().replace(',', '.'));
        const baseValue = this.initialSaleValue ?? 0;

        if (isNaN(parsedNew) || parsedNew <= baseValue) {
            this.saleValueChanged = false;

            this.$store.direct.commit.contractor.setCheckIfContractorClientHasExceededDebtLimit(false);
            this.$store.direct.commit.contractor.setCheckIfContractorPayerHasExceededDebtLimit(false);
            return;
        }

        this.saleValueChanged = true;
    }

    async assignSupervisorOrderIdDueToBranchChanged(currentBranchId: number | undefined) {
        this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("supervisor.changingTheBranchOfTheSupervisorTitle")}`,
                message: `${this.$t("supervisor.changingTheBranchOfTheSupervisorMessage")}`,
                links: [],
                options: { buttonColor: "white", layoutColor: "error" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.changeSupervisorBranchId();
                }
                else {
                    this.defaultLocationId = this.copyOfDefaultLocationId;
                }
            });
    }

    showContractorIsLockedAsClientDialog(contractor: ContractorDetailsForSupervisorRestModel) {
        this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("contractor.isLockedAsClientDialogTitle")}`,
                message: contractor.isLockedAsClientComment,
                links: [],
                options: { buttonColor: "white", layoutColor: "error" },
                buttonType: "ok"
            })
            .then(async confirm => {
                if (confirm) {
                    this.occurredErrorWhileSaving = false;
                }
            });
    }

    showContractorIsLockedAsCarrierDialog(contractor: ContractorDetailsForSupervisorRestModel) {
        this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("contractor.isLockedAsCarrierDialogTitle")}`,
                message: contractor.isLockedAsCarrierComment,
                links: [],
                options: { buttonColor: "white", layoutColor: "error" },
                buttonType: "ok"
            })
            .then(async confirm => {
                if (confirm) {
                    this.occurredErrorWhileSaving = false;
                }
            });
    }

    syncSelectedContractorsFromSupervisor() {
        if (this.supervisor.customerCompanyId != null && this.supervisor.customer != null) {
            this.selectedContractorSender = { text: this.supervisor.customer, value: this.supervisor.customerCompanyId, contractorSymbol: this.supervisor.customerCompanySymbol, additionalInfo: this.supervisor.customerCompanyAdditionalInfo } as ContractorSearchItemModel;
        }
        else {
            this.selectedContractorSender = { text: this.supervisor.customer, value: 0, contractorSymbol: "", additionalInfo: "" };
        }
        if (this.supervisor.shippingCompanyId != null && this.supervisor.shippingCompany != null) {
            this.selectedContractorCarrier = { text: this.supervisor.shippingCompany, value: this.supervisor.shippingCompanyId, contractorSymbol: this.supervisor.shippingCompanySymbol, additionalInfo: this.supervisor.shippingCompanyAdditionalInfo } as ContractorSearchItemModel;
        }
        else {
            this.selectedContractorCarrier = { text: this.supervisor.shippingCompany, value: 0, contractorSymbol: "", additionalInfo: "" };
        }
        if (this.supervisor.payerId != null && this.supervisor.payerName != null) {
            this.selectedContractorPayer = { text: this.supervisor.payerName, value: this.supervisor.payerId, additionalInfo: "" } as ContractorSearchItemModel;
        }
        else {
            this.selectedContractorPayer = { text: this.supervisor.payerName, value: 0, contractorSymbol: "", additionalInfo: "" };
        }
    }

    async created() {
        this.windowAddEventListener();

        this.$store.direct.dispatch.common.readLocalStorageApplicationStateData();
        this.integrationEnabled = false;
        this.encoryIntegrationEnabled = false;
        this.kpiEnabled = false;
        this.currentSupervisorCheckpoints = [];
        this.currentSupervisorPlaces = [];
        this.selectedContractorSender = { text: "", value: 0 } as ContractorSearchItemModel;
        this.selectedContractorCarrier = { text: "", value: 0 } as ContractorSearchItemModel;

        if (this.$route.params.id != undefined && this.$route.name != "Duplicate supervisor") {
            this.isEdited = true;
        }
        else {
            this.isFullDuplicating = this.$route.params.fullDuplication === "true" ? true : false;
        }

        if (this.supervisor.importantInfo != null && this.supervisor.importantInfo != undefined) {
            await this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("contractor.specialInfo")}`,
                    message: this.supervisor.importantInfo,
                    links: [],
                    options: { buttonColor: "primary", layoutColor: "primary" },
                    buttonType: "ok"
                })
                .then(async confirm => {
                    if (confirm) {
                        this.occurredErrorWhileSaving = false;
                    }
                });
        }

        this.$store.direct.dispatch.contractor.loadContractorAssets();
        this.$store.direct.dispatch.supervisor.loadSupervisorAssets();
        this.$store.direct.dispatch.settlementCommon.loadSettlementAssets();
        this.$store.direct.dispatch.common.loadVehicleTypeList({ source: "supervisor" });
        this.$store.direct.dispatch.supervisorEncory.loadTransportDocumentTypeList();
        this.$store.direct.dispatch.supervisor.loadSpecificGoodUnNumbers();
        this.$store.direct.dispatch.supervisor.loadSpecificGoodPackingGroups();


        if (this.supervisor.customerCompanyId != undefined) {
            await this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: this.supervisor.customerCompanyId, contractorType: ContractorTypes.Client })
        }
        if (this.supervisor.shippingCompanyId != undefined) {
            this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: this.supervisor.shippingCompanyId, contractorType: ContractorTypes.Carrier })
        }
        if (this.supervisor.payerId != undefined) {
            this.$store.direct.dispatch.contractor.getContractorDetailsForSupervisor({ contractorId: this.supervisor.payerId, contractorType: ContractorTypes.Payer })
        }
        this.syncSelectedContractorsFromSupervisor();

        if (this.supervisor.customerCompanyCustomInfoToSupervisor != null && this.supervisor.customerCompanyCustomInfoToSupervisor != undefined) {
            await this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("supervisor.importantInfoAboutContractor")}`,
                    message: this.supervisor.customerCompanyCustomInfoToSupervisor,
                    links: [],
                    options: { buttonColor: "primary", layoutColor: "primary" },
                    buttonType: "ok"
                })
                .then(async confirm => {
                    if (confirm) {
                        this.occurredErrorWhileSaving = false;
                    }
                });
        }

        if (this.supervisor.locationId == 8) {
            await this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("supervisor.needChangingSupervisorDepartmentDialogTitle")}`,
                    message: `${this.$t("supervisor.needChangingSupervisorDepartmentDialogMessage")}`,
                    links: [],
                    options: { buttonColor: "primary", layoutColor: "primary" },
                    buttonType: "ok"
                })
                .then(async confirm => {
                    if (confirm) {
                        this.occurredErrorWhileSaving = false;
                    }
                });
        }

        this.$store.direct.dispatch.supervisor.loadSupervisorAttachmentList();
        this.$store.direct.dispatch.supervisor.loadSupervisorProcedureList();

        if (!this.hasOriginalSupervisorId && this.supervisor.hasClonedSupervisors && this.supervisor.id != null) {
            await this.$store.direct.dispatch.supervisor.loadClonedSupervisorList({ supervisorId: this.supervisor.id });
        }

        this.setBrowserTabTitle();
    }

    mounted() {
        this.$nextTick(() => {
            const val = this.supervisor.saleValue;
            this.initialSaleValue = val != null ? parseFloat(val.toString().replace(',', '.')) : null;
            this.supervisorInitialized = true;
        });
        if (this.$refs.form != undefined) {
            const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        }
        if (this.isDroppedFromPreliminaryList == true) {
            this.supervisor.isPreliminary = false;
        }
    }

    beforeDestroy() {
        document.title = this.$store.direct.state.common.tabTitle;
    }

    windowAddEventListener() {
        window.addEventListener('beforeunload', (e) => {
            this.clearSupervisorLockedForEditingUntilValue();
        });
        window.addEventListener('unload', (e) => {
            this.clearSupervisorLockedForEditingUntilValue();
        });
        window.addEventListener('onbeforeunload', (e) => {
            this.clearSupervisorLockedForEditingUntilValue();
        });
        window.addEventListener('onunload', (e) => {
            this.clearSupervisorLockedForEditingUntilValue();
        });
    }

    clearDateTimePickerTimeTo(index: number) {
        this.currentSupervisorPlaces[index].timeTo = "";
    }

    showSupervisorIsEditedByAnotherUserDialog(isEditedByUserName: string) {
        this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("supervisor.orderIsCurrentlyBeingUsed")}`,
                message: `${this.$t("supervisor.orderIsCurrentlyBeingUsedBy")}` + isEditedByUserName,
                links: [],
                options: { buttonColor: "error", layoutColor: "error" },
                buttonType: "ok"
            });
    }

    updateSupervisorLockedForEditingUntilValueIsSet = false;
    updateSupervisorLockedForEditingUntilValue() {
        if (this.updateSupervisorLockedForEditingUntilValueIsSet == false) {
            this.updateSupervisorLockedForEditingUntilValueIsSet = true;
            this.updateSupervisorLockedForEditingUntilValueIntervalId = setInterval(() => {
                this.$store.direct.dispatch.supervisor.updateSupervisorLockedForEditingUntilValue({ supervisorId: this.supervisor.id });
            }, 20000);
        }
    }

    clearSupervisorLockedForEditingUntilValue() {
        if (!this.supervisorIsEditedByAnotherUser) {
            clearInterval(this.updateSupervisorLockedForEditingUntilValueIntervalId);
            this.$store.direct.dispatch.supervisor.clearSupervisorLockedForEditingUntilValue({ supervisorId: this.supervisor.id });
        }
    }

    async supervisorPlaceCountryChanged(place: SupervisorPlaceRestModel, index: number) {
        await this.supervisorPlacePostalCodeOrCountryChanged(place, index);
        await this.checkIfContractorCarrierPolicyIsActive();
    }

    async supervisorPlacePostalCodeOrCountryChanged(place: SupervisorPlaceRestModel, index: number) {
        if (this.supervisorPlaceHasCountryAndPostalCode(place)) {
            await this.$store.direct.dispatch.common.searchAddresses({ searchText: place.postalCode, additionalSearchText: place.country });
            if (this.addressFound.length > 0) {
                place.lat = this.addressFound[0]?.lat as number;
                place.lng = this.addressFound[0].lng as number;
                place.isLocationConfirmedByUser = true;
            }
            else {
                place.lat = undefined;
                place.lng = undefined;
                place.isLocationConfirmedByUser = false;
            }
            this.$forceUpdate();

            this.getDistanceBetweenSupervisorPlaces();
            this.changeNeedRecalculatingFreigntValue();
        }
    }

    supervisorPlaceHasCountryAndPostalCode(place: SupervisorPlaceRestModel) {
        const result = place.postalCode != null && place.postalCode.length > 3 && place.country != null && place.country.length > 1;
        return result;
    }

    async getDistanceBetweenSupervisorPlaces() {
        const allPlacesAreFilled = this.currentSupervisorPlaces.every((x: SupervisorPlaceRestModel) => {
            return x.lat != undefined && x.lng != undefined;
        });

        if (allPlacesAreFilled) {
            const placesCoordinates = this.currentSupervisorPlaces.map((x: SupervisorPlaceRestModel) => {
                return { lat: x.lat, lng: x.lng } as any;
            });
            const distance = await this.$store.direct.dispatch.common.getDistanceBetweenPlaces({ placesCoordinates: placesCoordinates });

            const doNotShowKilometersHint = this.currentSupervisorPlaces.some(place => place.country == "IT");
            if (!doNotShowKilometersHint) {
                this.supervisorKilometersHints = distance.toString();
            }
            else {
                this.supervisorKilometersHints = "";
            }
        }

    }

    placeItemSearch(place: SupervisorPlaceRestModel, index: number, searchTextType: string) {
        if (!this.localStorageApplicationStateData.supervisorEditingIsPlaceSuggestionsOn) {
            return;
        }
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            let currentPlace = this.currentSupervisorPlaces.find(x => { return x == place })
            if (currentPlace == undefined) {
                currentPlace = {
                    searchName: "",
                    searchPostalCode: "",
                    searchCity: "",
                } as SupervisorPlaceRestModel;
            }
            switch (searchTextType) {
                case "name":
                    {
                        this.$store.direct.dispatch.supervisor.searchSupervisorPlaceItems({ searchText: currentPlace.searchName, searchTextType: searchTextType });
                        break;
                    }
                case "postalCode":
                    {
                        this.$store.direct.dispatch.supervisor.searchSupervisorPlaceItems({ searchText: currentPlace.searchPostalCode, searchTextType: searchTextType });
                        break;
                    }
                case "city":
                    {
                        this.$store.direct.dispatch.supervisor.searchSupervisorPlaceItems({ searchText: currentPlace.searchCity, searchTextType: searchTextType });
                        break;
                    }
            }
        }, 1000);
    }

    handlePlaceNameInput(e: SupervisorPlaceRestModel) {
        if (typeof e == 'string') {
            const placeFound = this.placeNamesFound.find(x => x.additionalInfo == e);
            if (placeFound != undefined) {
                const placeFoundFromSupervisorPlaces = this.currentSupervisorPlaces.find(x => x.name == placeFound?.additionalInfo);
                const index = this.currentSupervisorPlaces.indexOf(placeFoundFromSupervisorPlaces as SupervisorPlaceRestModel)
                this.fillSupervisorPlaceFields(index, placeFound);
            }
        }
    }

    handlePlacePostalCodeInput(e: SupervisorPlaceRestModel) {
        if (typeof e == 'string') {
            const placeFound = this.placePostalCodesFound.find(x => x.additionalInfo == e);
            if (placeFound != undefined) {
                const placeFoundFromSupervisorPlaces = this.currentSupervisorPlaces.find(x => x.postalCode == placeFound?.additionalInfo);
                const index = this.currentSupervisorPlaces.indexOf(placeFoundFromSupervisorPlaces as SupervisorPlaceRestModel)
                this.fillSupervisorPlaceFields(index, placeFound);
            }
        }
    }

    handlePlaceCityInput(e: SupervisorPlaceRestModel) {
        if (typeof e == 'string') {
            const placeFound = this.placeCitiesFound.find(x => x.additionalInfo == e);
            if (placeFound != undefined) {
                const placeFoundFromSupervisorPlaces = this.currentSupervisorPlaces.find(x => x.city == placeFound?.additionalInfo);
                const index = this.currentSupervisorPlaces.indexOf(placeFoundFromSupervisorPlaces as SupervisorPlaceRestModel)
                this.fillSupervisorPlaceFields(index, placeFound);
            }
        }
    }

    fillSupervisorPlaceFields(index: number, placeFound: SupervisorPlaceRestModel) {
        setTimeout(() => {
            this.currentSupervisorPlaces[index].name = placeFound?.name as string;
            this.currentSupervisorPlaces[index].country = placeFound?.country as string;
            this.currentSupervisorPlaces[index].postalCode = placeFound?.postalCode as string;
            this.currentSupervisorPlaces[index].city = placeFound?.city as string;
            this.currentSupervisorPlaces[index].street = placeFound?.street as string;
            this.currentSupervisorPlaces[index].gpsCoordinates = placeFound?.gpsCoordinates as string;
            this.currentSupervisorPlaces[index].lat = placeFound?.lat as number;
            this.currentSupervisorPlaces[index].lng = placeFound?.lng as number;
            this.currentSupervisorPlaces[index].isLocationConfirmedByUser = true;

            this.supervisorPlacePostalCodeOrCountryChanged(this.currentSupervisorPlaces[index], index);
            this.supervisorPlaceCountryChanged(this.currentSupervisorPlaces[index], index);
        }, 1);
    }

    formatDateTime(list: any, prop: string): any {
        return list.map((item: any) => {
            if (item[prop]) {
                item[prop] = dayjs(item[prop]).format("YYYY-MM-DD HH:mm");
            }
            return item;
        });
    };

    formatSingleDateTimeValue(time: any) {
        return time != null ? dayjs(time).format("YYYY-MM-DD HH:mm") : "";
    }

    openGoogleMapsURL(lat: number, lng: number) {
        window.open("https://www.google.com/maps?q=" + lat + "," + lng, '_blank');
    }

    prepareValueForPlaceStampField(hasStamp: boolean) {
        return hasStamp ? this.$t('common.yes') : this.$t('common.no')
    }

    setIconColor(index: number): boolean {
        const currentPlace = this.currentSupervisorPlaces[index];
        if (currentPlace.isLocationConfirmedByUser == true && currentPlace.lat != null && currentPlace.lng != null && currentPlace.lat != 0 && currentPlace.lng != 0) {
            return true;
        }
        return false;
    }

    confirmCheckpointIsVisibleForContractor(checkpoint: SupervisorCheckpointRestModel) {
        if (checkpoint.isVisibleForContractor == true) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("supervisor.visibleForContractor")}`,
                    message: `${this.$t("supervisor.visibleForContractorMessage")}`,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "ok"
                })
        }
    }

    openLocationDialog(index: number) {
        if (!this.isSupervisorInHistoricalState) {
            this.$store.direct.commit.supervisor.setSupervisorPlace(this.currentSupervisorPlaces[index])
            this.$store.direct.dispatch.locationDialog
                .openDialog({
                    showDialog: true,
                    title: `${this.$t("supervisor.setLocation")}`
                })
                .then(async confirm => {
                    if (confirm) {
                        this.currentSupervisorPlaces[index].postalCode = this.supervisorPlace.postalCode;
                        this.currentSupervisorPlaces[index].lat = this.supervisorPlace.lat;
                        this.currentSupervisorPlaces[index].lng = this.supervisorPlace.lng;
                        this.currentSupervisorPlaces[index].isLocationConfirmedByUser = true;
                        this.$forceUpdate();
                    }
                });
        }
    }

    async downloadFile(fileId: number) {
        if (this.isSupervisorInHistoricalState) {
            await this.$store.direct.dispatch.supervisor.downloadFile({ fileId: fileId, forSupervisorMemento: true });
        }
        else {
            await this.$store.direct.dispatch.supervisor.downloadFile({ fileId: fileId, forSupervisorMemento: false });
        }
    }

    addNewPlaceForm() {
        if (this.isEdited == false && this.currentSupervisorPlaces.length == 0) {
            this.currentSupervisorPlaces.push({
                typeId: 1,
                time: "0001-01-01 00:00",
                unit: "palette",
                weightUnit: "kg",
                encoryUnAggregatedArray: [] as SupervisorPlaceEncoryAggregatedByUnRestModel[],
                attachmentList: [] as SupervisorPlaceAttachmentRestModel[],
                specificGoods: [] as SupervisorPlaceSpecificGoodRestModel[]
            } as SupervisorPlaceRestModel);
            this.currentSupervisorPlaces.push({
                typeId: 2,
                time: "0001-01-01 00:00",
                unit: "palette",
                weightUnit: "kg",
                encoryUnAggregatedArray: [] as SupervisorPlaceEncoryAggregatedByUnRestModel[],
                attachmentList: [] as SupervisorPlaceAttachmentRestModel[]
            } as SupervisorPlaceRestModel);
        }
        else {
            this.currentSupervisorPlaces.push({
                typeId: 1,
                time: "0001-01-01 00:00",
                unit: "palette",
                weightUnit: "kg",
                encoryUnAggregatedArray: [] as SupervisorPlaceEncoryAggregatedByUnRestModel[],
                attachmentList: [] as SupervisorPlaceAttachmentRestModel[],
                specificGoods: [] as SupervisorPlaceSpecificGoodRestModel[]
            } as SupervisorPlaceRestModel);
        }
    }

    removePlaceForm(index: number) {
        this.selectedPlacesIdcsForCreatingNewSupervisor.splice(index, 1);
        this.currentSupervisorPlaces[index].isDeleted = true;
        this.currentSupervisorPlaces.splice(index, 1);
    }

    addNewCheckpointForm() {
        this.currentSupervisorCheckpoints.push({
            isChecked: false,
            checkTime: dayjs().format("YYYY-MM-DD HH:mm"),
        } as SupervisorCheckpointRestModel);
    }

    removeCheckpointForm(index: number) {
        this.currentSupervisorCheckpoints[index].isDeleted = true;
        this.currentSupervisorCheckpoints.splice(index, 1);
    }

    syncSupervisorPlaceSearchFields() {
        this.currentSupervisorPlaces.forEach((place: SupervisorPlaceRestModel) => {
            place.name = place.searchName ?? place.name;
            place.postalCode = place.searchPostalCode ?? place.postalCode;
            place.city = place.searchCity ?? place.city;
            place.street = place.searchStreet ?? place.street;
        });
    }

    changeSupervisorPropertiesToUpperCase() {
        if (this.supervisor.registrationNumber != null && this.supervisor.registrationNumber != undefined) {
            this.supervisor.registrationNumber = this.supervisor.registrationNumber.replace(/\s/g, "");
            this.supervisor.registrationNumber = this.supervisor.registrationNumber.toUpperCase();
        }

        this.supervisor.saleValueCurrency = (this.supervisor.saleValueCurrency != null && this.supervisor.saleValueCurrency != undefined) ? this.supervisor.saleValueCurrency.toUpperCase() : this.supervisor.saleValueCurrency;
        this.supervisor.purchaseValueCurrency = (this.supervisor.purchaseValueCurrency != null && this.supervisor.purchaseValueCurrency != undefined) ? this.supervisor.purchaseValueCurrency.toUpperCase() : this.supervisor.purchaseValueCurrency;

        if (this.supervisor.driver1Name != null && this.supervisor.driver1Name != undefined) {
            if (this.supervisor.driver1Name.length == 0) {
                this.supervisor.driver1Name = undefined as any;
            }
            else {
                this.supervisor.driver1Name = this.supervisor.driver1Name.toUpperCase();
            }
        }

        if (this.supervisor.driver1Telephone != null && this.supervisor.driver1Telephone != undefined) {
            if (this.supervisor.driver1Telephone.length == 0) {
                this.supervisor.driver1Telephone = undefined as any;
            }
            else {
                this.supervisor.driver1Telephone = this.supervisor.driver1Telephone.toUpperCase();
            }
        }

        if (this.supervisor.driver2Name != null && this.supervisor.driver2Name != undefined) {
            if (this.supervisor.driver2Name.length == 0) {
                this.supervisor.driver2Name = undefined as any;
            }
            else {
                this.supervisor.driver2Name = this.supervisor.driver2Name.toUpperCase();
            }
        }

        if (this.supervisor.driver2Telephone != null && this.supervisor.driver2Telephone != undefined) {
            if (this.supervisor.driver2Telephone.length == 0) {
                this.supervisor.driver2Telephone = undefined as any;
            }
            else {
                this.supervisor.driver2Telephone = this.supervisor.driver2Telephone.toUpperCase();
            }
        }

        this.currentSupervisorPlaces.forEach((x: SupervisorPlaceRestModel) => {
            x.country = (x.country != null && x.country != undefined) ? x.country.toUpperCase() : x.country;
        });
    }

    async showKpiCheckingNeededDialog() {
        if (this.kpiEnabled) {
            const placesResult = this.currentSupervisorPlaces.every((x: SupervisorPlaceRestModel) => {
                return x.isChecked;
            });
            const checkpointResult = this.currentSupervisorCheckpoints.every((x: SupervisorCheckpointRestModel) => {
                return x.isChecked;
            });

            if (placesResult && checkpointResult) {
                const notAllKpiAreSet = this.supervisor.kpiReceiptDate == null || this.supervisor.kpiRepackaging == null || this.supervisor.kpiDocumentGeneration == null || this.supervisor.kpiFerryBoats == null || this.supervisor.kpiCustomDuties == null || this.supervisor.kpiLifts == null || this.supervisor.kpiStornos == null || this.supervisor.kpiAdditionalLoadingPoint == null;

                if (notAllKpiAreSet) {
                    await this.$store.direct.dispatch.confirm
                        .openConfirmDialog({
                            showConfirmDialog: true,
                            title: `${this.$t("supervisor.kpiCheckingNeededTitle")}`,
                            message: `${this.$t("supervisor.kpiCheckingNeededMessage")}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        });
                }
            }
        }
    }

    async saveSupervisorClick(backToSupervisorList: boolean = true): Promise<boolean> {
        await this.showKpiCheckingNeededDialog();

        this.syncSupervisorPlaceSearchFields();
        this.changeSupervisorPropertiesToUpperCase();

        if (this.supervisor.importantInfo != null && this.supervisor.importantInfo.length == 0) {
            this.supervisor.importantInfo = null as any;
        }

        const tempSelectedContractorSender: ContractorSearchItemModel | string = this.selectedContractorSender;
        const tempSelectedContractorCarrier: ContractorSearchItemModel | string = this.selectedContractorCarrier;
        const tempSelectedContractorPayer: ContractorSearchItemModel | string = this.selectedContractorPayer;

        if (tempSelectedContractorSender != null) {
            if (tempSelectedContractorSender.value != undefined && tempSelectedContractorSender.value != 0) {
                this.supervisor.customerCompanyId = tempSelectedContractorSender.value;
                this.supervisor.customer = tempSelectedContractorSender.text;
            }
            else {
                this.supervisor.customerCompanyId = null;
                if (typeof (this.selectedContractorSender) === "string") {
                    this.supervisor.customer = tempSelectedContractorSender as unknown as string;
                }
            }
        }
        else {
            this.supervisor.customerCompanyId = null;
            this.supervisor.customer = null as any;
        }

        if (tempSelectedContractorCarrier != null) {
            if (tempSelectedContractorCarrier.value != undefined && tempSelectedContractorCarrier.value != 0) {
                this.supervisor.shippingCompanyId = tempSelectedContractorCarrier.value;
                this.supervisor.shippingCompany = tempSelectedContractorCarrier.text;
            }
            else {
                this.supervisor.shippingCompanyId = null;
                if (typeof (this.selectedContractorCarrier) === "string") {
                    this.supervisor.shippingCompany = tempSelectedContractorCarrier as unknown as string;
                }
            }
        }
        else {
            this.supervisor.shippingCompanyId = null;
            this.supervisor.shippingCompany = null as any;
        }

        if (tempSelectedContractorPayer != null && tempSelectedContractorPayer.value != undefined && tempSelectedContractorPayer.value != 0) {
            this.supervisor.payerId = tempSelectedContractorPayer.value;
            this.supervisor.payerName = tempSelectedContractorPayer.text;
        }
        else {
            this.supervisor.payerId = null;
            this.supervisor.payerName = null as any;
        }

        this.currentSupervisorPlaces.forEach((x: SupervisorPlaceRestModel) => {
            if (x.typeId == 5) {
                x.count = "";
                x.unit = "";
                x.weight = "";
                x.weightUnit = "";
            }
            else {
                x.whoPaysForCustomClearanceTypeId = undefined;
            };

            if (x.encoryHandlingUnitAggregatedArray) {
                x.encoryHandlingUnitAggregatedArray.forEach((y: SupervisorPlaceEncoryHandlingUnitRestModel) => {
                    if (y.supervisorPlaceEncoryHandlingUnitParts) {
                        y.supervisorPlaceEncoryHandlingUnitParts.forEach((z: SupervisorPlaceEncoryHandlingUnitPartRestModel) => {
                            z.totalQuantity = parseFloat(z.totalQuantity.toString().replace(',', '.'));
                            z.totalNetWeightKg = parseFloat(z.totalNetWeightKg.toString().replace(',', '.'));
                        });
                    }
                });
            }
        });

        this.supervisor.checkpoints = this.currentSupervisorCheckpoints;
        this.supervisor.places = this.currentSupervisorPlaces;
        this.supervisor.locationId = this.defaultLocationId;

        this.supervisor.goodsAreSubjectToCustomClearance = !this.supervisor.places.every((x: SupervisorPlaceRestModel) => {
            return x.typeId != 5;
        });

        const parsedSaleValue: number | null = this.supervisor.saleValue != null ? parseFloat(this.supervisor.saleValue.toString().replace(',', '.')) : null;

        if (this.saleValueChanged) {
            const additionalValue = parsedSaleValue != null ? parsedSaleValue - (this.initialSaleValue ?? 0) : null;

            if (this.supervisor.customerCompanyId != null && this.supervisor.payerId == null) {
                await this.$store.direct.dispatch.contractor.checkIfContractorHasExceededDebtLimit({
                    contractorId: this.supervisor.customerCompanyId,
                    contractorType: ContractorTypes.Client,
                    additionalValue: additionalValue
                });
            }
            if (this.supervisor.payerId != null) {
                await this.$store.direct.dispatch.contractor.checkIfContractorHasExceededDebtLimit({
                    contractorId: this.supervisor.payerId,
                    contractorType: ContractorTypes.Payer,
                    additionalValue: additionalValue
                });
            }
        }

        let freightValueIsCorrect = true;
        let freightValueIsIncorrectMessage = "";
        const regExp = /[a-zA-Z]/g;

        if (this.supervisor.saleValue != null && regExp.test(this.supervisor.saleValue.toString())) {
            freightValueIsCorrect = false;
            freightValueIsIncorrectMessage = `${this.$t("supervisor.customerFreight")}` + " value is incorrect"
        }
        if (this.supervisor.purchaseValue != null && regExp.test(this.supervisor.purchaseValue.toString())) {
            freightValueIsCorrect = false;
            freightValueIsIncorrectMessage = `${this.$t("supervisor.forwarderFreight")}` + " value is incorrect"
        }

        if (this.supervisor.customerCompanyId != null && this.checkIfContractorClientHasExceededDebtLimit == true) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("contractor.contractorHasExceededDebtLimit")}`,
                    message: `${this.$t("contractor.contractorHasExceededDebtLimit")}` + ": " + this.supervisor.customer,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "ok"
                });
            return false;
        }

        if (this.supervisor.payerId != null && this.checkIfContractorPayerHasExceededDebtLimit == true) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("contractor.contractorHasExceededDebtLimit")}`,
                    message: `${this.$t("contractor.contractorHasExceededDebtLimit")}` + ": " + this.supervisor.payerName,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "ok"
                });
            return false;
        }

        if (this.supervisor.shippingCompanyId != null && this.contractorCarrierPolicyIsActiveResult.policyIsActive == false) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("supervisor.contractorCarrierPolicyIsNotActive")}`,
                    message: `${this.$t("supervisor.contractorCarrierPolicyIsNotActive")}` + ": " + this.contractorCarrierPolicyIsActiveResult.checkedPolicyType,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "ok"
                });
            return false;
        }
        else if (freightValueIsCorrect == false) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: freightValueIsIncorrectMessage,
                    message: freightValueIsIncorrectMessage,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "ok"
                });
            return false;
        }
        else {
            if (parsedSaleValue != null) {
                this.supervisor.saleValue = parsedSaleValue;
            }
            if (this.supervisor.purchaseValue) {
                this.supervisor.purchaseValue = parseFloat(this.supervisor.purchaseValue.toString().replace(',', '.'));
            }

            this.assignSupervisorPropertiesToSpecificGoods();

            if (!this.validateSupervisorPlaceSpecificGoods()) {
                return false;
            }

            if (this.isDroppedFromPreliminaryList) {
                this.canChangeRouteToSupervisorList = await this.$store.direct.dispatch.supervisor.saveSupervisor({ addingSupervisorFromPreliminary: true }) as boolean;
            }
            else {
                this.canChangeRouteToSupervisorList = await this.$store.direct.dispatch.supervisor.saveSupervisor() as boolean;
            }

            if (this.$refs.form != undefined) {
                const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
            }

            if (this.canChangeRouteToSupervisorList == false) {
                return false;
            }

            if (Object.keys(this.validationError).length === 0 && this.canChangeRouteToSupervisorList == true && backToSupervisorList == true) {
                this.backToList();
            }
            return true;
        }
    }

    assignSupervisorPropertiesToSpecificGoods(): void {
        this.currentSupervisorPlaces.forEach((place: SupervisorPlaceRestModel) => {
            if (place.specificGoods && place.specificGoods.length > 0) {
                place.specificGoods.forEach((good: SupervisorPlaceSpecificGoodRestModel) => {
                    good.isADR = this.supervisor.isADR;
                    good.extinguisher = this.supervisor.extinguisher;
                });
            }
        });
    }

    validateSupervisorPlaceSpecificGoods(): boolean {
        let specificGoodsValid = true;

        // First, check if places requiring specificGoods have at least one element
        //if (!this.isEdited) {
        //    for (let placeIndex = 0; placeIndex < this.currentSupervisorPlaces.length; placeIndex++) {
        //        const place = this.currentSupervisorPlaces[placeIndex];

        //        if (this.shouldShowSpecificGoods(place)) {
        //            if (!place.specificGoods || place.specificGoods.length === 0) {
        //                specificGoodsValid = false;
        //                const placeNumber = placeIndex + 1;
        //                this.$store.direct.dispatch.confirm.openConfirmDialog({
        //                    showConfirmDialog: true,
        //                    title: this.$t("common.validationErrorRequired").toString(),
        //                    message: `${this.$t("supervisor.place")} #${placeNumber}: ${this.$t("supervisor.specificGoods")} - ${this.$t("supervisor.atLeastOneSpecificGoodRequired")}`,
        //                    links: [],
        //                    options: { buttonColor: "error", layoutColor: "error" },
        //                    buttonType: "ok"
        //                });
        //                return false;
        //            }
        //        }
        //    }
        //}

        // Then validate individual fields in specificGoods
        for (let placeIndex = 0; placeIndex < this.currentSupervisorPlaces.length; placeIndex++) {
            const place = this.currentSupervisorPlaces[placeIndex];

            if (place.specificGoods && place.specificGoods.length > 0) {
                for (let goodIndex = 0; goodIndex < place.specificGoods.length; goodIndex++) {
                    const good = place.specificGoods[goodIndex];
                    const placeNumber = placeIndex + 1;
                    const goodNumber = goodIndex + 1;
                    const message = `Place #${placeNumber} - ${this.$t("supervisor.specificGoods")} #${goodNumber}: `

                    // Item
                    if (!good.specificGoodItemId || good.specificGoodItemId <= 0) {
                        specificGoodsValid = false;
                        this.$store.direct.dispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: this.$t("common.validationErrorRequired").toString(),
                            message: `${message} ${this.$t("supervisor.item")} ${this.$t("common.validationErrorRequired")}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        });
                        break;
                    }

                    // Quantity
                    if (!good.quantity || good.quantity <= 0) {
                        specificGoodsValid = false;
                        this.$store.direct.dispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: this.$t("common.validationErrorRequired").toString(),
                            message: `${message} #${goodNumber}: ${this.$t("supervisor.quantity")} ${this.$t("common.validationErrorRequired")}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        });
                        break;
                    }

                    // Net Weight
                    if (!good.netWeight || good.netWeight <= 0) {
                        specificGoodsValid = false;
                        this.$store.direct.dispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: this.$t("common.validationErrorRequired").toString(),
                            message: `${message} #${goodNumber}: ${this.$t("supervisor.netWeightInKg")} ${this.$t("common.validationErrorRequired")}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        });
                        break;
                    }

                    // UN Number
                    if ((good.isADR || good.extinguisher) && (!good.unNumberId || good.unNumberId <= 0)) {
                        specificGoodsValid = false;
                        this.$store.direct.dispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: this.$t("common.validationErrorRequired").toString(),
                            message: `${message} #${goodNumber}: ${this.$t("supervisor.un")} ${this.$t("common.validationErrorRequired")}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        });
                        break;
                    }

                    // Packing Group
                    if ((good.isADR || good.extinguisher) && (!good.packingGroupId || good.packingGroupId <= 0)) {
                        specificGoodsValid = false;
                        this.$store.direct.dispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: this.$t("common.validationErrorRequired").toString(),
                            message: `${message} #${goodNumber}: ${this.$t("supervisor.packingGroup")} ${this.$t("common.validationErrorRequired")}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        });
                        break;
                    }

                    // Vin - required
                    if (!good.vin || good.vin.length <= 0) {
                        specificGoodsValid = false;
                        this.$store.direct.dispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: this.$t("common.validationErrorRequired").toString(),
                            message: `${message} #${goodNumber}: VIN ${this.$t("common.validationErrorRequired")}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        });
                        break;
                    }

                    // Vin - max length
                    const vinMax = 96;
                    if (good.vin.length > vinMax) {
                        specificGoodsValid = false;

                        this.$store.direct.dispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: this.$t("common.validationError").toString(),
                            message: `${message} #${goodNumber}: ${this.$t("common.validationErrorMaxLength", {
                                field: "VIN",
                                length: vinMax,
                            })}`,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok",
                        });

                        break;
                    }
                }

                if (!specificGoodsValid) {
                    break;
                }
            }
        }

        return specificGoodsValid;
    }

    async openSendSupervisorCarrierDocumentEmailDialog(reloadSupervisorOnCancel: boolean) {
        this.$store.direct.commit.supervisor.setSendingEmailDialogEmailNote("");

        if (Object.keys(this.validationError).length === 0 && this.contractorCarrierPolicyIsActiveResult.policyIsActive == true && this.supervisor.userOpenedSupervisorInSafeLocation) {
            this.$store.direct.dispatch.supervisor.getSupervisorCarrierDocumentOrderRequirementList({ forSupervisor: true });
            this.$store.direct.dispatch.common.loadDispoEmailAddressList();
            this.$store.direct.dispatch.contractor.loadContractorAssets();
            this.$store.direct.dispatch.supervisor.loadSupervisorAssets();
            this.$store.direct.commit.supervisor.setSendingEmailDialogSendToEmailAddressArray([{ emailAddress: "" }]);
            this.$store.direct.dispatch.supervisor
                .openSendingEmailDialog({
                    showDialog: true,
                    title: `${this.$t("supervisor.saveAndSendEmailToCarrier")}`
                })
                .then(async confirm => {
                    if (confirm) {
                        try {
                            await this.$store.direct.dispatch.supervisor.sendSupervisorCarrierDocumentEmail({ supervisorId: this.supervisor.id, contractorCarrierId: this.contractorCarrierDetailsForSupervisor.id });
                            this.backToList();
                        }
                        catch (err: any) {
                            const errorMessage = err?.response?.data?.message || "Nie udalo sie wyslac emaila do przewoznika.";
                            await this.$store.direct.dispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: this.$t("common.error").toString(),
                                message: errorMessage,
                                links: [],
                                options: { buttonColor: "error", layoutColor: "error" },
                                buttonType: "ok"
                            });
                        }
                    }
                    else if (reloadSupervisorOnCancel) {
                        await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.supervisor.id });
                    }

                    this.$store.direct.commit.supervisor.setCurrentSupervisorCarrierDocument("");
                })
        }
    }

    async saveSupervisorAndSendSupervisorCarrierDocumentEmailClick() {
        this.canChangeRouteToSupervisorList = false;

        if (!this.supervisor.userOpenedSupervisorInSafeLocation) {
            await this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("common.youAreNotInSafeLocationOrYouDidNotOpenOrderInSafeLocationTitle")}`,
                    message: `${this.$t("common.youAreNotInSafeLocationOrYouDidNotOpenOrderInSafeLocationMessage")}`,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "ok"
                });

            this.canChangeRouteToSupervisorList = true;
        }
        else {
            if (!await this.saveSupervisorClick(false))
                return;

            this.canChangeRouteToSupervisorList = true;
            await this.openSendSupervisorCarrierDocumentEmailDialog(true);
        }
    }

    async sendSupervisorCarrierDocumentEmailWithoutSavingClick() {
        this.canChangeRouteToSupervisorList = false;

        if (!this.supervisor.userOpenedSupervisorInSafeLocation) {
            await this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("common.youAreNotInSafeLocationOrYouDidNotOpenOrderInSafeLocationTitle")}`,
                    message: `${this.$t("common.youAreNotInSafeLocationOrYouDidNotOpenOrderInSafeLocationMessage")}`,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "ok"
                });

            this.canChangeRouteToSupervisorList = true;
            return;
        }

        this.canChangeRouteToSupervisorList = true;
        await this.openSendSupervisorCarrierDocumentEmailDialog(false);
    }

    async checkIfContractorCarrierPolicyIsActive() {
        if (this.selectedContractorCarrier.value == null || this.currentSupervisorPlaces == null || this.currentSupervisorPlaces.length == 0) {
            this.contractorCarrierPolicyIsActiveResult = { policyIsActive: true };
            return;
        }

        const supervisorPlacesPlanningTimeSortedArray = this.currentSupervisorPlaces.map(x => x.time).sort();
        const lastSupervisorPlacesPlanningTime = supervisorPlacesPlanningTimeSortedArray[supervisorPlacesPlanningTimeSortedArray.length - 1];

        if (this.currentSupervisorPlaces.length == 0) {
            //if no places exist return true which means that carrier has active policy
            this.contractorCarrierPolicyIsActiveResult = { policyIsActive: true };
        }
        else if (this.currentSupervisorPlaces.every(x => x.country == this.contractorCarrierDetailsForSupervisor.country)) {
            await this.$store.direct.dispatch.contractor.checkIfContractorPolicyIsActive({ contractorId: this.selectedContractorCarrier.value as number, contractorPolicyTypeId: 0, checkDate: lastSupervisorPlacesPlanningTime });
            this.contractorCarrierPolicyIsActiveResult = { policyIsActive: this.checkIfContractorPolicyIsActive, checkedPolicyType: "National" };
        }
        else if (this.currentSupervisorPlaces.every(x => x.country == this.currentSupervisorPlaces[0].country) && this.currentSupervisorPlaces[0].country != this.contractorCarrierDetailsForSupervisor.country) {
            await this.$store.direct.dispatch.contractor.checkIfContractorPolicyIsActive({ contractorId: this.selectedContractorCarrier.value as number, contractorPolicyTypeId: 2, checkDate: lastSupervisorPlacesPlanningTime });
            this.contractorCarrierPolicyIsActiveResult = { policyIsActive: this.checkIfContractorPolicyIsActive, checkedPolicyType: "Cabotage" };
        }
        else {
            await this.$store.direct.dispatch.contractor.checkIfContractorPolicyIsActive({ contractorId: this.selectedContractorCarrier.value as number, contractorPolicyTypeId: 1, checkDate: lastSupervisorPlacesPlanningTime });
            this.contractorCarrierPolicyIsActiveResult = { policyIsActive: this.checkIfContractorPolicyIsActive, checkedPolicyType: "International" };
        }
    }

    async addNewContractorCarrier() {
        await this.$store.direct.dispatch.contractor.loadContractor({ types: [ContractorTypes.Carrier] });
        await this.$store.direct.dispatch.contractor.loadPolicy();
        this.$store.direct.commit.contractor.setPolicyList([] as ContractorPolisyRestModel[]);
        this.$store.direct.dispatch.supervisor
            .openContractorDialog({
                showDialog: true,
                title: `${this.$t("contractor.createNewContractorTitle")}`,
                contractorTypes: [ContractorTypes.Carrier],
                isContractorEdited: false,
            })
            .then(async confirm => {
                if (confirm) {
                    this.contractorCarrierSearchLoadItems(this.contractorCarrierSearch);
                }
                this.checkIfContractorCarrierPolicyIsActive();
            });
    }

    async editContractorCarrier() {
        await this.$store.direct.dispatch.contractor.loadContractor({ id: this.selectedContractorCarrier.value.toString() });
        await this.$store.direct.dispatch.contractor.loadPolicyList();
        this.$store.direct.dispatch.supervisor
            .openContractorDialog({
                showDialog: true,
                title: `${this.$t("contractor.editContractorTitle")}`,
                contractorTypes: [ContractorTypes.Carrier],
                isContractorEdited: true,
            })
            .then(async confirm => {
                if (confirm) {
                    this.contractorCarrierSearchLoadItems(this.contractorCarrierSearch);
                }
                this.checkIfContractorCarrierPolicyIsActive();
            });
    }

    async editContractorSender() {
        await this.$store.direct.dispatch.contractor.loadContractor({ id: this.selectedContractorSender.value.toString() });
        this.$store.direct.dispatch.supervisor
            .openContractorDialog({
                showDialog: true,
                title: `${this.$t("contractor.editContractorTitle")}`,
                contractorTypes: [ContractorTypes.Client],
                isContractorEdited: true,
            })
            .then(async confirm => {
                if (confirm) {
                    this.contractorSenderSearchLoadItems(this.contractorSenderSearch);
                }
            });
    }

    async addNewContractorSender() {
        await this.$store.direct.dispatch.contractor.loadContractor({ types: [ContractorTypes.Client] });
        this.$store.direct.dispatch.supervisor
            .openContractorDialog({
                showDialog: true,
                title: `${this.$t("contractor.createNewContractorTitle")}`,
                contractorTypes: [ContractorTypes.Client],
                isContractorEdited: false,
            })
            .then(async confirm => {
                if (confirm) {
                    this.contractorSenderSearchLoadItems(this.contractorSenderSearch);
                }
            });
    }

    async addNewCustomerContactPerson() {
        this.$store.direct.commit.contractor.setContractor({ id: this.selectedContractorSender.value } as ContractorRestModel);
        await this.$store.direct.dispatch.supervisor
            .openContractorContactPersonDialog({
                showDialog: true,
            })
            .then(async confirm => {
                if (confirm) {
                    await this.selectedContractorSenderChanged();
                }
            });
    }

    showClearCustomerContactPersonDialog() {
        const customerContactPerson = this.supervisor.customerContactPerson;

        this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("supervisor.clearCustomerContactPersonTitle")}`,
                message: `${this.$t("supervisor.clearCustomerContactPersonMessage")}`,
                links: [],
                options: { buttonColor: "error", layoutColor: "error" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    this.supervisor.customerContactPerson = {} as ListItemNumberModel;
                }
                else {
                    this.supervisor.customerContactPerson = customerContactPerson;
                }
            });
    }

    async mobileAppCancelOrder() {
        if (!this.isSupervisorInHistoricalState) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("supervisor.cancelOrderTitle")}`,
                    message: `${this.$t("supervisor.cancelOrderMessage")}`,
                    links: [],
                    options: { buttonColor: "error", layoutColor: "error" },
                    buttonType: "yes/no"
                })
                .then(async confirm => {
                    if (confirm) {
                        await this.$store.direct.dispatch.supervisor.mobileAppCancelOrder({ supervisorId: this.supervisor.id });
                        await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.supervisor.id });
                    }
                });
        }
    }

    async mobileAppOrderItemStateChange(supervisorPlaceId: number) {
        if (!this.isSupervisorInHistoricalState) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: `${this.$t("supervisor.confirmOrderTitle")}`,
                    message: `${this.$t("supervisor.confirmOrderMessage")}`,
                    links: [],
                    options: { buttonColor: "primary", layoutColor: "primary" },
                    buttonType: "yes/no"
                })
                .then(async confirm => {
                    if (confirm) {
                        await this.$store.direct.dispatch.supervisor.mobileAppOrderItemStateChange({ supervisorId: this.supervisor.id, supervisorPlaceId: supervisorPlaceId });
                        await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.supervisor.id });
                    }
                });
        }
    }

    async integrationClick() {
        if (this.isSupervisorInHistoricalState) {
            await this.$store.direct.dispatch.supervisor.getSupervisorIntegrations({ supervisorId: this.supervisor.supervisorMementoId, forSupervisorMemento: true });
        }
        else {
            await this.$store.direct.dispatch.supervisor.getSupervisorIntegrations({ supervisorId: this.supervisor.id, forSupervisorMemento: false });
        }
        this.openIntegrationDialog();
    }

    async encoryIntegrationClick() {
        if (this.isSupervisorInHistoricalState) {
            await this.$store.direct.dispatch.supervisorEncory.getSupervisorEncoryIntegrations({ supervisorId: this.supervisor.supervisorMementoId, forSupervisorMemento: true });
        }
        else {
            await this.$store.direct.dispatch.supervisorEncory.getSupervisorEncoryIntegrations({ supervisorId: this.supervisor.id, forSupervisorMemento: false });
        }
        this.openEncoryIntegrationDialog();
    }

    openIntegrationDialog() {
        this.$store.direct.dispatch.supervisor
            .openIntegrationDialog({
                showDialog: true,
                title: `${this.$t("supervisor.integration")}`
            })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.updateSupervisorIntegrations()
                    await this.$store.direct.dispatch.supervisor.reloadSupervisorEditedAtValue({ id: this.supervisor.id });
                }
            })
    }

    openEncoryIntegrationDialog() {
        this.$store.direct.dispatch.supervisorEncory
            .openEncoryIntegrationDialog({
                showDialog: true,
                title: `${this.$t("supervisor.encoryIntegration")}`
            })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisorEncory.updateSupervisorEncoryIntegrations()
                    await this.$store.direct.dispatch.supervisor.reloadSupervisorEditedAtValue({ id: this.supervisor.id });
                }
            })
    }

    async generateSupervisorEncoryHandlingUnitComment() {
        const supervisorEncoryHandlingUnitComment = await this.$store.direct.dispatch.supervisorEncory.generateSupervisorEncoryHandlingUnitComment({ supervisorId: this.supervisor.id }) as string;
        this.supervisor.comment = supervisorEncoryHandlingUnitComment;
    }

    async attachmentCreateClick() {
        await this.$store.direct.dispatch.supervisor.openAttachmentDialog()
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.reloadSupervisorEditedAtValue({ id: this.supervisor.id });
                }
            });
    }

    async procedureCreateClick() {
        await this.$store.direct.commit.supervisor.setProcedure({} as SupervisorProcedureRestModel);
        await this.$store.direct.commit.supervisor.setProcedureFileList([] as ListItemNumberModel[]);
        await this.$store.direct.dispatch.supervisor.openProcedureDialog()
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.reloadSupervisorEditedAtValue({ id: this.supervisor.id });
                }
            });
    }

    loadProcedure(procedureId: number) {
        this.$store.direct.dispatch.supervisor.loadProcedure({ procedureId: procedureId });
        this.$store.direct.dispatch.supervisor.openProcedureDialog()
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.reloadSupervisorEditedAtValue({ id: this.supervisor.id });
                }
            });
    }

    async deleteSuperviorProcedure(item: SupervisorProcedureRestModel) {
        await this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: this.$t("supervisor.deleteSupervisorProcedureTitle").toString(),
                message: this.$t("supervisor.deleteSupervisorProcedureMessage").toString() + ": " + item.vin,
                links: [],
                options: { buttonColor: "error", layoutColor: "red" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.deleteSuperviorProcedure({ procedureId: item.id });
                    await this.$store.direct.dispatch.supervisor.loadSupervisorProcedureList();
                }
            })
    }

    async downloadSuperviorProcedureDocument(item: SupervisorProcedureRestModel) {
        await this.$store.direct.dispatch.supervisor.downloadSupervisorProcedureDocument({ procedureId: item.id });
    }

    archiveSupervisor() {
        this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("supervisor.archive")}: "${this.supervisor.orderId}"`,
                message: `${this.$t("supervisor.archiveMessage")}`,
                links: [],
                options: { buttonColor: "primary", layoutColor: "primary" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    this.canChangeRouteToSupervisorList = false;
                    const saveResult = await this.saveSupervisorClick(true);

                    if (!saveResult) {
                        this.canChangeRouteToSupervisorList = true;
                        return;
                    }

                    if (Object.keys(this.validationError).length === 0 && this.contractorCarrierPolicyIsActiveResult.policyIsActive == true) {
                        const result = await this.$store.direct.dispatch.supervisor.changeSupervisorArchiveValue({ supervisorId: this.supervisor.id, isArchived: true });
                        if (result == true) {
                            this.backToList();
                        }
                        else {
                            await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.supervisor.id });
                        }
                    }
                    this.canChangeRouteToSupervisorList = true;
                }
            });
    }

    hideSupervisor() {
        this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: `${this.$t("supervisor.deleteOrder")}: "${this.supervisor.orderId}"`,
                message: `${this.$t("supervisor.deleteOrderMessage")}`,
                links: [],
                options: { buttonColor: "error", layoutColor: "error" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    this.canChangeRouteToSupervisorList = false;
                    const result = await this.$store.direct.dispatch.supervisor.hideSupervisor({ supervisorId: this.supervisor.id });
                    this.canChangeRouteToSupervisorList = true;
                    if (result == true) {
                        this.backToList();
                    }
                }
            });
    }

    copyPlaceAddress(index: number) {
        const place = this.currentSupervisorPlaces[index];
        const placeAddress = place.name + ", " + place.street + ", " + place.country + " " + place.postalCode + ", " + place.city;
        const textarea = document.createElement('textarea');
        textarea.value = placeAddress;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    async generateTransportDocument(index: number) {
        this.currentSupervisorLoadingPlaceId = this.currentSupervisorPlaces[index].id;
        this.currentSupervisorUnloadingPlaceId = this.currentSupervisorPlaces[this.currentSupervisorPlaces.length - 1].id;

        await this.$store.direct.dispatch.supervisorTransportDocument
            .openAdrDialog({
                showAdrDialog: true,
                title: `${this.$t("supervisorTransportDocument.dialogTitle")}`,
            })
    }

    async generateDgnDocument(index: number) {
        this.currentSupervisorLoadingPlaceId = this.currentSupervisorPlaces[index].id;
        this.currentSupervisorUnloadingPlaceId = this.currentSupervisorPlaces[this.currentSupervisorPlaces.length - 1].id;

        await this.$store.direct.dispatch.supervisorTransportDocument
            .openDgnDialog({
                showDgnDialog: true,
                title: `${this.$t("supervisor.generateDgn")}`,
            })
    }

    convertFirstPlaceWeight(place: SupervisorPlaceRestModel, outputUnit: string): number {
        if (outputUnit == "t") {
            if (place.weightUnit == "t") {
                return parseFloat(place.weight);
            }
            else if (place.weightUnit == "kg") {
                const weightAsNumber = parseFloat(place.weight);
                return weightAsNumber / 1000;
            }
            else {
                return 0;
            }
        }
        else if (outputUnit == "kg") {
            if (place.weightUnit == "t") {
                const weightAsNumber = parseFloat(place.weight);
                return weightAsNumber * 1000;
            }
            else if (place.weightUnit == "kg") {
                return parseFloat(place.weight);
            }
        }
        return 0;
    }

    vehicleSize = "";
    required_truck_bodies = [] as string[];
    generateRequiredVehicleSizeAndTruckBodiesFromVehicleType() {
        switch (this.supervisor.vehicleType) {
            case "caddy": {
                this.vehicleSize = "bus";
                this.required_truck_bodies = ["open-box"];
                break;
            }
            case "sprinter": {
                this.vehicleSize = "bus";
                this.required_truck_bodies = ["open-box"];
                break;
            }
            case "luton van": {
                this.vehicleSize = "bus";
                this.required_truck_bodies = ["curtainsider", "standard-tent"];
                break;
            }
            case "7,5t": {
                this.vehicleSize = "solo";
                this.required_truck_bodies = ["curtainsider", "standard-tent"];
                break;
            }
            case "12t": {
                this.vehicleSize = "solo";
                this.required_truck_bodies = ["curtainsider", "standard-tent"];
                break;
            }
            case "40t": {
                this.vehicleSize = "lorry";
                this.required_truck_bodies = ["curtainsider", "standard-tent"];
                break;
            }
            default: {
                break;
            }
        }
    }

    otherRequirements = [] as string[];
    generateOtherRequirements() {
        if (this.supervisor.isADR) {
            this.otherRequirements.push("7_adr");
        }
        if (this.supervisor.tailLift) {
            this.otherRequirements.push("3_lift");
        }
    }

    prepareTransEuFreightFromSupervisor() {
        const firstPlace = this.supervisor.places[0];
        const lastPlace = this.supervisor.places[this.supervisor.places.length - 1];
        const placeLoadingWeight = this.convertFirstPlaceWeight(firstPlace, "t");
        this.generateRequiredVehicleSizeAndTruckBodiesFromVehicleType();
        this.generateOtherRequirements();

        this.transEuFreight = {
            publish: true,
            external_source: "",
            capacity: placeLoadingWeight,
            payment: {
                price: {
                    period: {
                        days: 60,
                        payment: "deferred",
                    }
                }
            },
            requirements: {
                is_ftl: true,
                vehicle_size: this.vehicleSize,
                required_truck_bodies: this.required_truck_bodies,
                other_requirements: this.otherRequirements
            },
            loads: [],
            spots: [
                {
                    spot_order: 1,
                    place: {
                        address: {
                            country: firstPlace.country,
                            postal_code: firstPlace.postalCode,
                            locality: firstPlace.city
                        }
                    },
                    operations: [
                        {
                            operation_order: 1,
                            type: "loading",
                            timespans: {
                                beginAsString: firstPlace.time,
                                endAsAsString: firstPlace.time
                            }
                        }
                    ]
                },
                {
                    spot_order: 2,
                    place: {
                        address: {
                            country: lastPlace.country,
                            postal_code: lastPlace.postalCode,
                            locality: lastPlace.city
                        }
                    },
                    operations: [
                        {
                            operation_order: 1,
                            type: "unloading",
                            timespans: {
                                beginAsString: lastPlace.time,
                                endAsAsString: lastPlace.time
                            }
                        }
                    ]
                }
            ]
        } as TransEuFreightRestModel;
    }

    prepareCourierNetFreightFromSupervisor() {
        const firstPlace = this.supervisor.places[0];
        const lastPlace = this.supervisor.places[this.supervisor.places.length - 1];
        const placeLoadingWeight = this.convertFirstPlaceWeight(firstPlace, "kg");

        this.courierNetFreight = {
            reference: this.supervisor.id.toString(),
            startCountryCode: firstPlace.country,
            startZip: firstPlace.postalCode,
            startCity: firstPlace.city,
            destinationCountryCode: lastPlace.country,
            destinationZip: lastPlace.postalCode,
            destinationCity: lastPlace.city,
            loadingBeginDate: firstPlace.time,
            deliveryBeginDate: lastPlace.time,
            packages: [
                {
                    weight: placeLoadingWeight,
                } as CourierNetPackageRestModel,
            ]
        } as CourierNetFreightRestModel;
    }

    async sendFreightToFreightExchanges() {
        this.prepareTransEuFreightFromSupervisor();
        this.prepareCourierNetFreightFromSupervisor();

        await this.$store.direct.dispatch.freightExchange
            .openSendFreightToFreightExchangesDialog({
                showDialog: true
            })
            .then(async confirm => {
                if (confirm) {
                    this.$store.direct.commit.freightExchange.setTransEuFreight({} as TransEuFreightRestModel);
                }
            });
    }

    async deleteSuperviorAttachment(item: SupervisorAttachmentRestModel) {
        await this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: this.$t("supervisor.deleteSupervisorAttachmentTitle").toString(),
                message: this.$t("supervisor.deleteSupervisorAttachmentMessage").toString() + ": " + item.name,
                links: [],
                options: { buttonColor: "error", layoutColor: "red" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.deleteSuperviorAttachment({ fileId: item.id });
                    await this.$store.direct.dispatch.supervisor.loadSupervisorAttachmentList();
                }
            })
    }

    async createNewSupervisor() {
        const newTab = window.open('', '_blank');
        if (newTab) {
            try {
                const selectedPlacesIdcsArray = this.selectedPlacesIdcsForCreatingNewSupervisor.join(',');
                const createSupervisorUrl = `${window.location.origin}/supervisor/create?oldSupervisorId=${this.supervisor.id}&selectedPlacesIdcsArray=${selectedPlacesIdcsArray}`;
                newTab.location.href = createSupervisorUrl;
            } catch (error) {
                console.error('Failed to create supervisor:', error);
                newTab.close();
            }
        } else {
            console.error('Failed to open a new tab.');
        }
    }

    async getHandlingUnitDetailsByLoadCarrierNumber(index: number) {
        const loadCarrierNumber = this.currentSupervisorPlaces[index].loadCarrierNumber;
        if (loadCarrierNumber != undefined) {
            const encoryHandlingUnitAggregated = await this.$store.direct.dispatch.supervisorEncory.getHandlingUnitDetailsByLoadCarrierNumber({ loadCarrierNumber: loadCarrierNumber }) as SupervisorPlaceEncoryHandlingUnitRestModel;

            if (this.currentSupervisorPlaces[index].encoryHandlingUnitAggregatedArray == undefined) {
                this.currentSupervisorPlaces[index].encoryHandlingUnitAggregatedArray = [];
            }

            this.currentSupervisorPlaces[index].encoryHandlingUnitAggregatedArray.push(encoryHandlingUnitAggregated);
            this.currentSupervisorPlaces[index].name = encoryHandlingUnitAggregated.dealerAddressName;
            this.currentSupervisorPlaces[index].street = encoryHandlingUnitAggregated.dealerAddressStreet;
            this.currentSupervisorPlaces[index].postalCode = encoryHandlingUnitAggregated.dealerAddressPostalCode;
            this.currentSupervisorPlaces[index].city = encoryHandlingUnitAggregated.dealerAddressCity;
            this.currentSupervisorPlaces[index].country = "DE";
            this.currentSupervisorPlaces[index].transportDocumentContactPerson = encoryHandlingUnitAggregated.primaryContactDetails;
            this.currentSupervisorPlaces[index].loadCarrierNumber = undefined;

            this.supervisorPlacePostalCodeOrCountryChanged(this.currentSupervisorPlaces[index], index);

            this.$forceUpdate();
        }
    }

    deleteHandlingUnit(placeIndex: number, huIndex: number) {
        this.currentSupervisorPlaces[placeIndex].encoryHandlingUnitAggregatedArray.splice(huIndex, 1);
        this.$forceUpdate();
    }

    supervisorPlaceHandlingUnitPartChanged(hu: SupervisorPlaceEncoryHandlingUnitRestModel) {
        const netWeightSum = hu.supervisorPlaceEncoryHandlingUnitParts
            .reduce(
                (sum, part) =>
                    sum + Number(part.totalNetWeightKg),
                0
            );

        const tare = Number(hu.tareWeightKg ?? 0);
        hu.netWeightKg = netWeightSum;
        hu.grossWeightKg = netWeightSum + tare;
    }

    generateEncoryDocument(placeIndex: number, unIndex: number) {
        const supervisorLoadingPlaceId = this.currentSupervisorPlaces[placeIndex].id;
        const supervisorUnloadingPlaceId = this.currentSupervisorPlaces[this.currentSupervisorPlaces.length - 1].id;

        const un = this.currentSupervisorPlaces[placeIndex].encoryUnAggregatedArray[unIndex];
        this.$store.direct.dispatch.supervisorEncory.generateAndGetSupervisorTransporDocumentFile({ transportDocumentUnNumber: un.un, supervisorLoadingPlaceId: supervisorLoadingPlaceId, supervisorUnloadingPlaceId: supervisorUnloadingPlaceId, totalNetWeightKg: un.totalNetWeightKg, totalQuantity: un.totalQuantity });
    }

    fillEncoryUnloadingPlaceDetails(index: number) {
        this.currentSupervisorPlaces[index].name = "RLP Encory";
        this.currentSupervisorPlaces[index].street = "Lise-Meitner-Str. 2";
        this.currentSupervisorPlaces[index].postalCode = "41415";
        this.currentSupervisorPlaces[index].city = "Grevenbroich";
        this.currentSupervisorPlaces[index].country = "DE";

        this.currentSupervisorPlaces[index].isLocationConfirmedByUser = true;
        this.currentSupervisorPlaces[index].lat = 51.08461088294029;
        this.currentSupervisorPlaces[index].lng = 6.623177279490337;

        this.$forceUpdate();
    }

    showSendingSmsDialog(phoneNumber: string) {
        this.sendingSmsDialogPhoneNumber = phoneNumber.replace(/\s/g, "");;
        this.$store.direct.dispatch.supervisor.openSendingSmsDialog()
    }

    async calculateContractorSenderFreightBasedOnSupervisorProject(calculatingByAccounting: boolean) {
        await this.generateCountrySelectors();

        const model =
            {
                calculatingByAccounting: calculatingByAccounting,
                startCountryCode: this.currentSupervisorPlaces[0].country,
                endCountryCode: this.currentSupervisorPlaces[this.currentSupervisorPlaces.length - 1].country,
                numberOfKilometers: this.supervisor.numberOfKilometers,
                vehicleType: this.supervisor.vehicleType,
                contractorSenderId: this.selectedContractorSender.value,
                kpiRepackaging: this.supervisor.kpiRepackaging,
                kpiRepackagingMultiplicator: this.supervisor.kpiRepackagingMultiplicator,
                kpiDocumentGeneration: this.supervisor.kpiDocumentGeneration,
                kpiDocumentGenerationMultiplicator: this.supervisor.kpiDocumentGenerationMultiplicator,
                kpiFerryBoats: this.supervisor.kpiFerryBoats,
                kpiFerryBoatsMultiplicator: this.supervisor.kpiFerryBoatsMultiplicator,
                kpiFerryBoatsCountries: this.supervisor.kpiFerryBoatsCountries,
                isCustomKpiFerryBoats: this.supervisor.isCustomKpiFerryBoats,
                customKpiFerryBoatsPrice: this.supervisor.customKpiFerryBoatsPrice,
                kpiCustomDuties: this.supervisor.kpiCustomDuties,
                kpiCustomDutiesMultiplicator: this.supervisor.kpiCustomDutiesMultiplicator,
                kpiLifts: this.supervisor.kpiLifts,
                kpiLiftsMultiplicator: this.supervisor.kpiLiftsMultiplicator,
                kpiStornos: this.supervisor.kpiStornos,
                kpiStornosMultiplicator: this.supervisor.kpiStornosMultiplicator,
                kpiAdditionalLoadingPoint: this.supervisor.kpiAdditionalLoadingPoint,
                kpiAdditionalLoadingPointMultiplicator: this.supervisor.kpiAdditionalLoadingPointMultiplicator,
                kpiScan: this.supervisor.kpiScan,
                kpiScanMultiplicator: this.supervisor.kpiScanMultiplicator
            } as SupervisorProjectFreightCalculationRestModel;

        const result = await this.$store.direct.dispatch.supervisor.calculateContractorSenderFreightBasedOnSupervisorProject({ model: model }) as any;

        if (calculatingByAccounting) {
            this.supervisor.freightCalculationForAccounting = result.calculationDetails;
            this.supervisor.hasSaleValueBeenRecalculatedByAccounting = true;
            this.supervisor.saleValueBeforeRecalculationByAccounting = this.supervisor.saleValue;
            this.supervisor.saleValue = result.contractorSenderFreightPrice.toFixed(2);
        }
        else {
            this.supervisor.freightCalculation = result.calculationDetails;
            this.supervisor.hasSaleValueBeenRecalculatedByAccounting = false;
            this.supervisor.freightCalculationForAccounting = null;
        }
        this.needRecalculatingFreight = false;
    }

    async calculateContractorSenderFreightBasedOnSupervisorEncoryProject(calculatingByAccounting: boolean) {

        const model =
            {
                calculatingByAccounting: calculatingByAccounting,
                supervisorId: this.supervisor.id,
            } as SupervisorEncoryProjectFreightCalculationRestModel;

        const result = await this.$store.direct.dispatch.supervisorEncory.calculateContractorSenderFreightBasedOnSupervisorEncoryProject({ model: model }) as any;

        if (calculatingByAccounting) {
            this.supervisor.freightCalculationForAccounting = result.calculationDetails;
            this.supervisor.hasSaleValueBeenRecalculatedByAccounting = true;
            this.supervisor.saleValueBeforeRecalculationByAccounting = this.supervisor.saleValue;
            this.supervisor.saleValue = result.contractorSenderFreightPrice.toFixed(2);
        }
        else {
            this.supervisor.freightCalculation = result.calculationDetails;
            this.supervisor.hasSaleValueBeenRecalculatedByAccounting = false;
            this.supervisor.freightCalculationForAccounting = null;
        }
        this.needRecalculatingFreight = false;
    }

    async generateCountrySelectors() {
        this.changeNeedRecalculatingFreigntValue();

        if (!this.supervisor.kpiFerryBoats) {
            this.supervisor.kpiFerryBoatsCountries = undefined as any;
            return;
        }
        else if (this.supervisor.kpiFerryBoats && this.supervisor.kpiFerryBoatsMultiplicator == undefined) {
            this.supervisor.kpiFerryBoatsMultiplicator = 1;
        }

        const multiplicator = Number(this.supervisor.kpiFerryBoatsMultiplicator);
        let kpiFerryBoatsCountriesLength = 0;

        if (this.supervisor.kpiFerryBoatsCountries == null) {
            this.supervisor.kpiFerryBoatsCountries = [];

        }
        else {
            kpiFerryBoatsCountriesLength = this.supervisor.kpiFerryBoatsCountries.length;
        }
        if (multiplicator > kpiFerryBoatsCountriesLength) {
            const itemsToAdd = multiplicator - kpiFerryBoatsCountriesLength;
            this.supervisor.kpiFerryBoatsCountries.push(...Array(itemsToAdd).fill(null));
        }
        else if (multiplicator < kpiFerryBoatsCountriesLength) {
            this.supervisor.kpiFerryBoatsCountries.splice(multiplicator);
        }
    }

    isCustomKpiFerryBoatsChanged() {
        this.changeNeedRecalculatingFreigntValue();

        if (!this.supervisor.isCustomKpiFerryBoats) {
            this.supervisor.customKpiFerryBoatsPrice = undefined;
        }
    }

    kpiFerryBoatsChanged() {
        this.kpiChanged("kpiFerryBoats")
        this.generateCountrySelectors();
    }

    kpiChanged(kpiType: string) {
        this.changeNeedRecalculatingFreigntValue();

        if (kpiType == "kpiRepackaging" && this.supervisor.kpiRepackaging == null) {
            this.supervisor.kpiRepackaging = undefined;
            this.supervisor.kpiRepackagingMultiplicator = undefined;
        }
        if (kpiType == "kpiDocumentGeneration" && this.supervisor.kpiDocumentGeneration == null) {
            this.supervisor.kpiDocumentGeneration = undefined;
            this.supervisor.kpiDocumentGenerationMultiplicator = undefined;
        }
        if (kpiType == "kpiCustomDuties" && this.supervisor.kpiCustomDuties == null) {
            this.supervisor.kpiCustomDuties = undefined;
            this.supervisor.kpiCustomDutiesMultiplicator = undefined;
        }
        if (kpiType == "kpiFerryBoats" && this.supervisor.kpiFerryBoats == null) {
            this.supervisor.kpiFerryBoats = undefined;
            this.supervisor.kpiFerryBoatsMultiplicator = undefined;
        }
        if (kpiType == "kpiLifts" && this.supervisor.kpiLifts == null) {
            this.supervisor.kpiLifts = undefined;
            this.supervisor.kpiLiftsMultiplicator = undefined;
        }
        if (kpiType == "kpiStornos" && this.supervisor.kpiStornos == null) {
            this.supervisor.kpiStornos = undefined;
            this.supervisor.kpiStornosMultiplicator = undefined;
        }
        if (kpiType == "kpiAdditionalLoadingPoint" && this.supervisor.kpiAdditionalLoadingPoint == null) {
            this.supervisor.kpiAdditionalLoadingPoint = undefined;
            this.supervisor.kpiAdditionalLoadingPointMultiplicator = undefined;
        }
        if (kpiType == "kpiScan" && this.supervisor.kpiScan == null) {
            this.supervisor.kpiScan = undefined;
            this.supervisor.kpiScanMultiplicator = undefined;
        }
    }

    changeNeedRecalculatingFreigntValue() {
        this.needRecalculatingFreight = true;
    }

    filteredTransporeonIntegrationStates(placeTypeId: number) {
        if (placeTypeId == 1) {
            return this.transporeonIntegrationStates.filter(item => (item.source == "loading" || item.source == "all"));
        } else if (placeTypeId == 2) {
            return this.transporeonIntegrationStates.filter(item => (item.source == "unloading" || item.source == "all"));
        }
        return [];
    }

    get isContractorSenderSelected(): boolean {
        const sender = this.selectedContractorSender;
        return sender != null && typeof (sender) != "string" && sender.value != undefined && sender.value != 0;
    }

    get isContractorPayerSelected(): boolean {
        const payer = this.selectedContractorPayer;
        return payer != null && typeof (payer) != "string" && payer.value != undefined && payer.value != 0;
    }

    get isPayerSelectedIfRequired(): boolean {
        return !this.supervisor.isPayerRequired || this.isContractorPayerSelected;
    }

    async confirmTransporeonTransportOrder() {
        if (!this.isContractorSenderSelected || !this.isPayerSelectedIfRequired) {
            return;
        }

        const isPayerRequired = this.supervisor.isPayerRequired == true;
        const result = await this.$store.direct.dispatch.transporeon.confirmTransporeonTransportOrder({
            supervisorId: this.supervisor.id,
            customerCompanyId: this.selectedContractorSender.value,
            saleValueCurrency: this.supervisor.saleValueCurrency != null ? this.supervisor.saleValueCurrency.toUpperCase() : this.supervisor.saleValueCurrency,
            paymentTermSale: this.supervisor.paymentTermSale != undefined ? this.supervisor.paymentTermSale : null,
            isPayerRequired: isPayerRequired,
            payerId: isPayerRequired && this.isContractorPayerSelected ? this.selectedContractorPayer.value : null
        });

    }

    async mergeWithSupervisorFromTranporeonTransportOrder() {
        this.canChangeRouteToSupervisorList = false;
        const saveResult = await this.saveSupervisorClick(false);
        this.canChangeRouteToSupervisorList = true;
        if (saveResult && Object.keys(this.validationError).length === 0 && this.transporeonSupervisorId != null) {
            const result = await this.$store.direct.dispatch.transporeon.mergeSupervisorWithSupervisorFromTranporeonTransportOrder({ baseSupervisorId: this.supervisor.id, transporeonSupervisorId: this.transporeonSupervisorId });
            this.transporeonSupervisorId = null;
        }
    }

    async moveToMarwayPlClick() {
        const saveResult = await this.saveSupervisorClick(false);
        if (!saveResult || Object.keys(this.validationError).length !== 0) return;

        await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.supervisor.id });
        await this.$store.direct.dispatch.register.loadCurrentUserBranchList();
        this.selectedDepartmentIdForMove = null;
        this.showMoveToBranchDialog = true;
    }

    async confirmMoveToBranchClick() {
        if (this.selectedDepartmentIdForMove == null) return;
        this.showMoveToBranchDialog = false;

        const newTab = window.open('', '_blank');

        try {
            const result = await this.$store.direct.dispatch.supervisor.cloneSupervisorToBranch({ supervisorId: this.supervisor.id, departmentId: this.selectedDepartmentIdForMove }) as any;
            if (!result?.isSuccess || !result?.object?.id) {
                if (newTab) {
                    newTab.close();
                }
                return;
            }

            await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.supervisor.id });
            this.syncSelectedContractorsFromSupervisor();

            if (newTab) {
                newTab.location.href = `${window.location.origin}/supervisor/edit/${result.object.id}`;
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    openMailingContractorCarrierDialog() {
        const firstPlace = this.currentSupervisorPlaces[0];
        const lastPlace = this.currentSupervisorPlaces[this.currentSupervisorPlaces.length - 1];

        const mailingContractorCarrierEmailData = {
            loading: { postalCode: firstPlace.postalCode, city: firstPlace.city, country: firstPlace.country, time: firstPlace.time } as MailingContractorCarrierEmailPlaceDataModel,
            unloading: { postalCode: lastPlace.postalCode, city: lastPlace.city, country: lastPlace.country, time: lastPlace.time } as MailingContractorCarrierEmailPlaceDataModel,
            count: firstPlace.count,
            unit: firstPlace.unit,
            weight: firstPlace.weight,
            weightUnit: firstPlace.weightUnit,
            selectedVehicles: [] as ListItemNumberModel[],
            adr: this.supervisor.isADR,
            lift: this.supervisor.tailLift,
            openRoof: false,
            frigo: this.supervisor.frigo,
            isDedicatedTransport: this.supervisor.isDedicatedTransport,
        } as MailingContractorCarrierEmailDataModel;

        this.$store.direct.commit.mailing.setMailingContractorCarrierEmailData(mailingContractorCarrierEmailData);

        this.$store.direct.dispatch.mailing.openMailingContractorCarrierDialog({
            showMailingDialog: true,
        });
    }

    async loadSupervisorPlaceAttachments(place: SupervisorPlaceRestModel) {
        if (place.attachmentList == undefined) {
            place.attachmentList = [] as SupervisorPlaceAttachmentRestModel[];
        }

        const placeId = place.id ?? 0;
        place.attachmentList = await this.$store.direct.dispatch.supervisor.loadSupervisorPlaceAttachmentList({ placeId: placeId, mementoPoint: null }) as SupervisorPlaceAttachmentRestModel[];
    }

    async placeAttachmentCreateClick(place: SupervisorPlaceRestModel, index: number) {
        const placeId = place.id ?? 0;
        await this.$store.direct.dispatch.supervisor.openPlaceAttachmentDialog({ placeId: placeId })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.reloadSupervisorEditedAtValue({ id: this.supervisor.id });
                }
                this.$store.direct.commit.supervisor.setPlaceAttachmentDialogAttachments([] as SupervisorPlaceAttachmentRestModel[])
            });
        place.attachmentList = await this.$store.direct.dispatch.supervisor.loadSupervisorPlaceAttachmentList({ placeId: placeId, mementoPoint: null }) as SupervisorPlaceAttachmentRestModel[];
        this.$forceUpdate();
    }

    async downloadPlaceFile(placeFileId: number) {
        if (this.isSupervisorInHistoricalState) {
            await this.$store.direct.dispatch.supervisor.downloadPlaceFile({ placeFileId: placeFileId, forSupervisorMemento: true });
        }
        else {
            await this.$store.direct.dispatch.supervisor.downloadPlaceFile({ placeFileId: placeFileId, forSupervisorMemento: false });
        }
    }

    async deleteSuperviorPlaceAttachment(place: SupervisorPlaceRestModel, item: SupervisorPlaceAttachmentRestModel, attachmentIndex: number) {
        await this.$store.direct.dispatch.confirm
            .openConfirmDialog({
                showConfirmDialog: true,
                title: this.$t("supervisor.deleteSupervisorAttachmentTitle").toString(),
                message: this.$t("supervisor.deleteSupervisorAttachmentMessage").toString() + ": " + item.name,
                links: [],
                options: { buttonColor: "error", layoutColor: "red" },
                buttonType: "yes/no"
            })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.deleteSuperviorPlaceAttachment({ placeFileId: item.id });
                }
            });
        place.attachmentList = await this.$store.direct.dispatch.supervisor.loadSupervisorPlaceAttachmentList({ placeId: place.id as number, mementoPoint: null }) as SupervisorPlaceAttachmentRestModel[];
        this.$forceUpdate();
    }

    setSupervisorAsUnassigned(place: SupervisorPlaceRestModel, index: number) {
        if (place.isChecked == true && place.typeId == 1) {
            this.supervisor.assignedToUserId = undefined;
        }
    }

    shouldShowSpecificGoods(place: SupervisorPlaceRestModel): boolean {
        const isLoadingPlace = place.typeId === 1;
        const selectedContractorId = this.selectedContractorSender?.value;
        const isBMW = selectedContractorId != null && this.bmwCustomerIdcs != undefined && this.bmwCustomerIdcs.includes(selectedContractorId);
        return isBMW && isLoadingPlace;
    }

    addSpecificGood(placeIndex: number) {
        if (!this.currentSupervisorPlaces[placeIndex].specificGoods) {
            this.currentSupervisorPlaces[placeIndex].specificGoods = [];
        }

        this.currentSupervisorPlaces[placeIndex].specificGoods!.push({} as SupervisorPlaceSpecificGoodRestModel);

        this.$forceUpdate();
    }

    removeSpecificGood(placeIndex: number, goodIndex: number) {
        this.currentSupervisorPlaces[placeIndex].specificGoods!.splice(goodIndex, 1);
        this.$forceUpdate();
    }

    loadSpecificGoodItemsFromSupervisorPlaces(places: SupervisorPlaceRestModel[]) {
        if (!places || places.length === 0) {
            return;
        }

        this.supervisorPlaceSpecificGoodItemsFromPlaces = [];

        places.forEach((place: SupervisorPlaceRestModel) => {
            if (place.specificGoods && place.specificGoods.length > 0) {
                place.specificGoods.forEach((good: SupervisorPlaceSpecificGoodRestModel) => {
                    if (good.specificGoodItemId && good.specificGoodItemMaterial) {
                        const exists = this.supervisorPlaceSpecificGoodItemsFromPlaces.some(
                            (x: SupervisorPlaceSpecificGoodItemRestModel) => x.id === good.specificGoodItemId
                        );

                        if (!exists) {
                            this.supervisorPlaceSpecificGoodItemsFromPlaces.push({
                                id: good.specificGoodItemId,
                                material: good.specificGoodItemMaterial,
                                materialDescription: good.specificGoodItemMaterialDescription,
                            } as SupervisorPlaceSpecificGoodItemRestModel);
                        }
                    }
                });
            }
        });
    }

    async addNewSpecificGoodItem(placeIndex: number, goodIndex: number) {
        await this.$store.direct.dispatch.supervisor.loadSpecificGoodItem();

        this.$store.direct.dispatch.supervisor
            .openSpecificGoodItemDialog({
                showDialog: true,
                title: `${this.$t("supervisor.supervisorPlaceSpecificGoodItemCreateNewSpecificGoodItem")}`
            })
    }

    handleSpecificGoodItemSelection(good: SupervisorPlaceSpecificGoodRestModel, placeIndex: number, goodIndex: number) {
        const selectedItem = this.supervisorPlaceSpecificGoodItemFound.find(
            x => x.id === good.specificGoodItemId
        );

        if (selectedItem) {
            good.specificGoodItemName = selectedItem.name;
            good.specificGoodItemMaterialDescription = selectedItem.materialDescription;
        }
    }

    goToSender() {
        const target = '#anchor-sender'

        const stickyH =
            (this.$refs.stickyMenu as HTMLElement | undefined)?.offsetHeight ?? 0

        const extra = 16

        const options: any = {
            duration: 300,
            offset: stickyH + extra,
            easing: 'easeInOutCubic',
        }

        if (this.$refs.scrollArea) {
            options.container = this.$refs.scrollArea
        }

        const goTo = (this.$vuetify as any)?.goTo
        if (goTo) {
            goTo(target, options)
            return
        }

        const el = document.querySelector(target)
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    goToCarrier() {
        const target = '#anchor-carrier'

        const stickyH =
            (this.$refs.stickyMenu as HTMLElement | undefined)?.offsetHeight ?? 0

        const extra = 16

        const options: any = {
            duration: 300,
            offset: stickyH + extra,
            easing: 'easeInOutCubic',
        }

        if (this.$refs.scrollArea) {
            options.container = this.$refs.scrollArea
        }

        const goTo = (this.$vuetify as any)?.goTo
        if (goTo) {
            goTo(target, options)
            return
        }

        const el = document.querySelector(target)
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    goToOriginalSupervisor() {
        if (!this.hasOriginalSupervisorId) return;

        this.openSupervisorEditInNewTab(this.supervisor.originalSupervisorId!);
    }

    goToClonedSupervisor(supervisorId: number) {
        this.openSupervisorEditInNewTab(supervisorId);
    }

    openSupervisorEditInNewTab(supervisorId: number) {
        if (!supervisorId) return;

        const routeData = this.$router.resolve({
            name: "Edit supervisor",
            params: {
                id: supervisorId.toString()
            }
        });

        window.open(routeData.href, "_blank");
    }

    destroyed() {
        this.clearSupervisorLockedForEditingUntilValue();
        this.$store.direct.commit.supervisor.setSupervisor({} as SupervisorRestModel);
        this.$store.direct.commit.supervisor.setClonedSupervisorList([] as ListItemNumberModel[]);
        this.contractorSenderDetailsForSupervisor = {} as ContractorDetailsForSupervisorRestModel;
        this.contractorCarrierDetailsForSupervisor = {} as ContractorDetailsForSupervisorRestModel;
        this.$store.direct.commit.supervisor.setValidationError({} as any);
        this.$store.direct.commit.supervisor.setIsDroppedFromPreliminaryList(false);
        this.isSupervisorInHistoricalState = false;
        this.isSupervisorCopied = false;
        this.isFullDuplicating = false;
        this.$store.direct.commit.freightExchange.setTransEuFreight({} as TransEuFreightRestModel);
        this.contractorCarrierEmailList = [] as ListItemNumberModel[];
    }

    backToList() {
        if (this.backToSupervisorArchiveListForSettlement) {
            this.$router.push({ path: "/supervisor/archive-list-for-settlement" });
        }
        else if (this.backToSupervisorAllOrdersList) {
            this.$router.push({ name: "Supervisor all orders list" });
        }
        else if (this.supervisor.isArchived) {
            this.$router.push({ name: "Supervisor archive list" });
        }
        else {
            this.$router.push({ path: "/supervisor/list" });
        }
        this.backToSupervisorArchiveListForSettlement = false;
        this.isSupervisorCopied = false;
    }
}
